
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fXYLR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68ed51f9e1612abe38768085b9e3fc4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9fb8191ece16144$var$_react = $b9fb8191ece16144$var$_interopRequireDefault((parcelRequire("42omo")));

var $b9fb8191ece16144$var$_peopleGroup = $b9fb8191ece16144$var$_interopRequireDefault((parcelRequire("lebfc")));

var $b9fb8191ece16144$var$_peopleGroup2 = $b9fb8191ece16144$var$_interopRequireDefault((parcelRequire("duHPY")));
function $b9fb8191ece16144$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9fb8191ece16144$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $b9fb8191ece16144$var$_react.default.createElement($b9fb8191ece16144$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $b9fb8191ece16144$var$_peopleGroup2.default
    }, props));
$b9fb8191ece16144$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $b9fb8191ece16144$var$_default = module.exports.default = $b9fb8191ece16144$var$PeopleGroupIcon;

});

parcelRegister("3gPdG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4acee959545f8daaa48d71dd0f20de76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $261a98e35660b612$var$_react = $261a98e35660b612$var$_interopRequireDefault((parcelRequire("42omo")));

var $261a98e35660b612$var$_comment = $261a98e35660b612$var$_interopRequireDefault((parcelRequire("1yB28")));

var $261a98e35660b612$var$_comment2 = $261a98e35660b612$var$_interopRequireDefault((parcelRequire("kOV42")));
function $261a98e35660b612$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommentIcon.
 * This component is CommentIcon, with `UNSAFE_fallbackIcon` set to "CommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $261a98e35660b612$var$CommentIcon = (props)=>/*#__PURE__*/ $261a98e35660b612$var$_react.default.createElement($261a98e35660b612$var$_comment.default, Object.assign({
        name: "CommentIcon",
        LEGACY_fallbackIcon: $261a98e35660b612$var$_comment2.default
    }, props));
$261a98e35660b612$var$CommentIcon.displayName = 'CommentIconMigration';
var $261a98e35660b612$var$_default = module.exports.default = $261a98e35660b612$var$CommentIcon;

});

parcelRegister("1yB28", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33181fb6c3dda951a22e3b4873cc95fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1225b183379acbc1$var$_react = $1225b183379acbc1$var$_interopRequireDefault((parcelRequire("42omo")));

var $1225b183379acbc1$var$_baseNew = $1225b183379acbc1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1225b183379acbc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1225b183379acbc1$var$CommentIcon = (props)=>/*#__PURE__*/ $1225b183379acbc1$var$_react.default.createElement($1225b183379acbc1$var$_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$1225b183379acbc1$var$CommentIcon.displayName = 'CommentIcon';
var $1225b183379acbc1$var$_default = module.exports.default = $1225b183379acbc1$var$CommentIcon;

});

parcelRegister("aSNrY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("flZlQ")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("flZlQ")).Icon);

var $flZlQ = parcelRequire("flZlQ");


});

parcelRegister("flZlQ", function(module, exports) {
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $578104b7f620e843$var$svgStyles = null;
const $578104b7f620e843$var$iconStyles = null;
const $578104b7f620e843$var$smallIconStyles = null;
const $578104b7f620e843$var$scaleStyles = null; /**
                           * For windows high contrast mode
                           */ 
const $578104b7f620e843$var$baseHcmStyles = null;
const $578104b7f620e843$var$scaleSize = null;
const $578104b7f620e843$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $578104b7f620e843$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $578104b7f620e843$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
}; /**
              * __Icon__
              *
              * An icon is used as a visual representation of common actions and commands to provide context.
              *
              * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
              * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
              */ 
const $578104b7f620e843$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, LEGACY_primaryColor: LEGACY_primaryColor, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, LEGACY_margin: LEGACY_margin, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined; // Fall back to old icon
    if (FallbackIcon && !(0, $dh538.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $l998X.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor ?? color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $578104b7f620e843$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
            fill: "none" // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            ,
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $578104b7f620e843$var$coreSizeSmall[spacing] : $578104b7f620e843$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var $578104b7f620e843$export$2e2bcd8739ae039 = $578104b7f620e843$export$f04a61298a47a40f;
module.exports["Icon"] = $578104b7f620e843$export$f04a61298a47a40f;
module.exports["default"] = $578104b7f620e843$export$2e2bcd8739ae039;

});

parcelRegister("kOV42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f284bdeea38d8491$var$_react = $f284bdeea38d8491$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f284bdeea38d8491$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f284bdeea38d8491$var$CommentIcon = (props)=>/*#__PURE__*/ $f284bdeea38d8491$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props));
$f284bdeea38d8491$var$CommentIcon.displayName = 'CommentIcon';
var $f284bdeea38d8491$var$_default = module.exports.default = $f284bdeea38d8491$var$CommentIcon;

});

parcelRegister("id7ja", function(module, exports) {
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $3f1a80b6c7238c21$var$iconStyles = null;
const $3f1a80b6c7238c21$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $3f1a80b6c7238c21$var$baseHcmStyles = null;
const $3f1a80b6c7238c21$var$primaryEqualsSecondaryHcmStyles = null;
const $3f1a80b6c7238c21$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * @deprecated Custom Icon is deprecated and will be removed from `atlaskit/icon` in an upcoming major release. Please use either an existing icon from @atlaskit/icon or @atlaskit/icon-lab, or contributing to @atlaskit/icon-lab directly. For third party logos, use an SVG element along with a label.
                                             *
                                             * An icon is used as a visual representation of common actions and commands to provide context.
                                             *
                                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
                                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
                                             */ 
const $3f1a80b6c7238c21$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $l998X.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $3f1a80b6c7238c21$var$sizeStyles[size]
        ])
    });
});
var $3f1a80b6c7238c21$export$2e2bcd8739ae039 = $3f1a80b6c7238c21$export$f04a61298a47a40f;
module.exports["Icon"] = $3f1a80b6c7238c21$export$f04a61298a47a40f;
module.exports["default"] = $3f1a80b6c7238c21$export$2e2bcd8739ae039;

});

parcelRegister("7D93v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77421a4093efbe74a1bbe8da5d5c5bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58e3332a192cc383$var$_react = $58e3332a192cc383$var$_interopRequireDefault((parcelRequire("42omo")));

var $58e3332a192cc383$var$_peopleGroup = $58e3332a192cc383$var$_interopRequireDefault((parcelRequire("lebfc")));

var $58e3332a192cc383$var$_people = $58e3332a192cc383$var$_interopRequireDefault((parcelRequire("f9sHQ")));
function $58e3332a192cc383$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58e3332a192cc383$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $58e3332a192cc383$var$_react.default.createElement($58e3332a192cc383$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $58e3332a192cc383$var$_people.default
    }, props));
$58e3332a192cc383$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $58e3332a192cc383$var$_default = module.exports.default = $58e3332a192cc383$var$PeopleGroupIcon;

});

parcelRegister("f9sHQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b07df6bc2f0d437a$var$_react = $b07df6bc2f0d437a$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b07df6bc2f0d437a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b07df6bc2f0d437a$var$PeopleIcon = (props)=>/*#__PURE__*/ $b07df6bc2f0d437a$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props));
$b07df6bc2f0d437a$var$PeopleIcon.displayName = 'PeopleIcon';
var $b07df6bc2f0d437a$var$_default = module.exports.default = $b07df6bc2f0d437a$var$PeopleIcon;

});

parcelRegister("fZtQj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad20bbceb59bcdcbded64441a3f93ce4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba43b3b17a3275e6$var$_react = $ba43b3b17a3275e6$var$_interopRequireDefault((parcelRequire("42omo")));

var $ba43b3b17a3275e6$var$_baseNew = $ba43b3b17a3275e6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ba43b3b17a3275e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba43b3b17a3275e6$var$ImageIcon = (props)=>/*#__PURE__*/ $ba43b3b17a3275e6$var$_react.default.createElement($ba43b3b17a3275e6$var$_baseNew.default, Object.assign({
        name: "ImageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$ba43b3b17a3275e6$var$ImageIcon.displayName = 'ImageIcon';
var $ba43b3b17a3275e6$var$_default = module.exports.default = $ba43b3b17a3275e6$var$ImageIcon;

});

parcelRegister("chO1Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $024eeefea93f1216$var$_react = $024eeefea93f1216$var$_interopRequireDefault((parcelRequire("42omo")));

var $024eeefea93f1216$var$_baseNew = $024eeefea93f1216$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $024eeefea93f1216$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $024eeefea93f1216$var$FileIcon = (props)=>/*#__PURE__*/ $024eeefea93f1216$var$_react.default.createElement($024eeefea93f1216$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$024eeefea93f1216$var$FileIcon.displayName = 'FileIcon';
var $024eeefea93f1216$var$_default = module.exports.default = $024eeefea93f1216$var$FileIcon;

});

parcelRegister("2Yaht", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::563b591bbaa180fc5c3a0e9071f2faa1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $229928ea1c8fbc33$var$_react = $229928ea1c8fbc33$var$_interopRequireDefault((parcelRequire("42omo")));

var $229928ea1c8fbc33$var$_baseNew = $229928ea1c8fbc33$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $229928ea1c8fbc33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $229928ea1c8fbc33$var$VideoIcon = (props)=>/*#__PURE__*/ $229928ea1c8fbc33$var$_react.default.createElement($229928ea1c8fbc33$var$_baseNew.default, Object.assign({
        name: "VideoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$229928ea1c8fbc33$var$VideoIcon.displayName = 'VideoIcon';
var $229928ea1c8fbc33$var$_default = module.exports.default = $229928ea1c8fbc33$var$VideoIcon;

});

parcelRegister("e3TOY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5ae331244e5ce5f0d911605ea315070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3cca56e09704fd9$var$_react = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("42omo")));

var $a3cca56e09704fd9$var$_baseNew = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3cca56e09704fd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3cca56e09704fd9$var$AudioIcon = (props)=>/*#__PURE__*/ $a3cca56e09704fd9$var$_react.default.createElement($a3cca56e09704fd9$var$_baseNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$a3cca56e09704fd9$var$AudioIcon.displayName = 'AudioIcon';
var $a3cca56e09704fd9$var$_default = module.exports.default = $a3cca56e09704fd9$var$AudioIcon;

});

parcelRegister("1zLiv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $125dbf99fbd0a2ae$var$_react = $125dbf99fbd0a2ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $125dbf99fbd0a2ae$var$_baseNew = $125dbf99fbd0a2ae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $125dbf99fbd0a2ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $125dbf99fbd0a2ae$var$ChartBarIcon = (props)=>/*#__PURE__*/ $125dbf99fbd0a2ae$var$_react.default.createElement($125dbf99fbd0a2ae$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$125dbf99fbd0a2ae$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $125dbf99fbd0a2ae$var$_default = module.exports.default = $125dbf99fbd0a2ae$var$ChartBarIcon;

});

parcelRegister("9Q2dU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $729ab1e57404246c$var$_react = $729ab1e57404246c$var$_interopRequireDefault((parcelRequire("42omo")));

var $729ab1e57404246c$var$_baseNew = $729ab1e57404246c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $729ab1e57404246c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $729ab1e57404246c$var$LockLockedIcon = (props)=>/*#__PURE__*/ $729ab1e57404246c$var$_react.default.createElement($729ab1e57404246c$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$729ab1e57404246c$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $729ab1e57404246c$var$_default = module.exports.default = $729ab1e57404246c$var$LockLockedIcon;

});

parcelRegister("5Gq9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42352a0768f2e71e$var$_react = $42352a0768f2e71e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $42352a0768f2e71e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $42352a0768f2e71e$var$AddIcon = (props)=>/*#__PURE__*/ $42352a0768f2e71e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props));
$42352a0768f2e71e$var$AddIcon.displayName = 'AddIcon';
var $42352a0768f2e71e$var$_default = module.exports.default = $42352a0768f2e71e$var$AddIcon;

});

parcelRegister("fJmzg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b73c9073fe0cc266$var$_react = $b73c9073fe0cc266$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b73c9073fe0cc266$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b73c9073fe0cc266$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $b73c9073fe0cc266$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props));
$b73c9073fe0cc266$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $b73c9073fe0cc266$var$_default = module.exports.default = $b73c9073fe0cc266$var$ArrowLeftIcon;

});

parcelRegister("eEQFA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aabda837fabfb2b1$var$_react = $aabda837fabfb2b1$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $aabda837fabfb2b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aabda837fabfb2b1$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aabda837fabfb2b1$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props));
$aabda837fabfb2b1$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $aabda837fabfb2b1$var$_default = module.exports.default = $aabda837fabfb2b1$var$ArrowRightIcon;

});

parcelRegister("9umf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e882b778fd9ce4b$var$_react = $6e882b778fd9ce4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $6e882b778fd9ce4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6e882b778fd9ce4b$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $6e882b778fd9ce4b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props));
$6e882b778fd9ce4b$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $6e882b778fd9ce4b$var$_default = module.exports.default = $6e882b778fd9ce4b$var$ArrowUpIcon;

});

parcelRegister("eCByP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa51c011ba15f6d5$var$_react = $aa51c011ba15f6d5$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $aa51c011ba15f6d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa51c011ba15f6d5$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $aa51c011ba15f6d5$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$aa51c011ba15f6d5$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $aa51c011ba15f6d5$var$_default = module.exports.default = $aa51c011ba15f6d5$var$CheckCircleIcon;

});

parcelRegister("7jrhz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $552f787c678b01a6$var$_react = $552f787c678b01a6$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $552f787c678b01a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $552f787c678b01a6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $552f787c678b01a6$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$552f787c678b01a6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $552f787c678b01a6$var$_default = module.exports.default = $552f787c678b01a6$var$ChevronLeftLargeIcon;

});

parcelRegister("k1A8C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e93feee5a2a51f4b$var$_react = $e93feee5a2a51f4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e93feee5a2a51f4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e93feee5a2a51f4b$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $e93feee5a2a51f4b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props));
$e93feee5a2a51f4b$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $e93feee5a2a51f4b$var$_default = module.exports.default = $e93feee5a2a51f4b$var$ChevronRightIcon;

});

parcelRegister("dskUg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cbe1b75fd65566d$var$_react = $9cbe1b75fd65566d$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9cbe1b75fd65566d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9cbe1b75fd65566d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9cbe1b75fd65566d$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props));
$9cbe1b75fd65566d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9cbe1b75fd65566d$var$_default = module.exports.default = $9cbe1b75fd65566d$var$ChevronRightLargeIcon;

});

parcelRegister("ge0Ua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcfea7d783028047$var$_react = $bcfea7d783028047$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $bcfea7d783028047$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bcfea7d783028047$var$CrossIcon = (props)=>/*#__PURE__*/ $bcfea7d783028047$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$bcfea7d783028047$var$CrossIcon.displayName = 'CrossIcon';
var $bcfea7d783028047$var$_default = module.exports.default = $bcfea7d783028047$var$CrossIcon;

});

parcelRegister("3UCaN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d943673e2bf9141$var$_react = $2d943673e2bf9141$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $2d943673e2bf9141$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2d943673e2bf9141$var$DownloadIcon = (props)=>/*#__PURE__*/ $2d943673e2bf9141$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props));
$2d943673e2bf9141$var$DownloadIcon.displayName = 'DownloadIcon';
var $2d943673e2bf9141$var$_default = module.exports.default = $2d943673e2bf9141$var$DownloadIcon;

});

parcelRegister("6Dqb4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d4ab0ec33bc7b15$var$_react = $4d4ab0ec33bc7b15$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $4d4ab0ec33bc7b15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d4ab0ec33bc7b15$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $4d4ab0ec33bc7b15$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props));
$4d4ab0ec33bc7b15$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $4d4ab0ec33bc7b15$var$_default = module.exports.default = $4d4ab0ec33bc7b15$var$DragHandlerIcon;

});

parcelRegister("1Nklh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14ea25955970d799$var$_react = $14ea25955970d799$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $14ea25955970d799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $14ea25955970d799$var$EditIcon = (props)=>/*#__PURE__*/ $14ea25955970d799$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props));
$14ea25955970d799$var$EditIcon.displayName = 'EditIcon';
var $14ea25955970d799$var$_default = module.exports.default = $14ea25955970d799$var$EditIcon;

});

parcelRegister("Dlgdv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07642289979b5f61$var$_react = $07642289979b5f61$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $07642289979b5f61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $07642289979b5f61$var$EditFilledIcon = (props)=>/*#__PURE__*/ $07642289979b5f61$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props));
$07642289979b5f61$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $07642289979b5f61$var$_default = module.exports.default = $07642289979b5f61$var$EditFilledIcon;

});

parcelRegister("ln6ck", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8f08db7abd71d7a$var$_react = $f8f08db7abd71d7a$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f8f08db7abd71d7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8f08db7abd71d7a$var$EditorAddIcon = (props)=>/*#__PURE__*/ $f8f08db7abd71d7a$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props));
$f8f08db7abd71d7a$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $f8f08db7abd71d7a$var$_default = module.exports.default = $f8f08db7abd71d7a$var$EditorAddIcon;

});

parcelRegister("fVPpU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9941033e39abace$var$_react = $b9941033e39abace$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b9941033e39abace$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b9941033e39abace$var$EditorAlignImageCenterIcon = (props)=>/*#__PURE__*/ $b9941033e39abace$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m4-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props));
$b9941033e39abace$var$EditorAlignImageCenterIcon.displayName = 'EditorAlignImageCenterIcon';
var $b9941033e39abace$var$_default = module.exports.default = $b9941033e39abace$var$EditorAlignImageCenterIcon;

});

parcelRegister("dm7sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b931e21319898eb$var$_react = $9b931e21319898eb$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9b931e21319898eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b931e21319898eb$var$EditorAlignImageRightIcon = (props)=>/*#__PURE__*/ $9b931e21319898eb$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props));
$9b931e21319898eb$var$EditorAlignImageRightIcon.displayName = 'EditorAlignImageRightIcon';
var $9b931e21319898eb$var$_default = module.exports.default = $9b931e21319898eb$var$EditorAlignImageRightIcon;

});

parcelRegister("fgThH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1e33bf55e6e7a89$var$_react = $b1e33bf55e6e7a89$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b1e33bf55e6e7a89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b1e33bf55e6e7a89$var$EditorAttachmentIcon = (props)=>/*#__PURE__*/ $b1e33bf55e6e7a89$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M17.222 11.557 12.11 16.64a3.01 3.01 0 0 1-4.238.004 2.97 2.97 0 0 1 .002-4.21L13.339 7a1.75 1.75 0 0 1 2.472-.002c.683.679.684 1.775.002 2.452l-5.126 5.095a.493.493 0 0 1-.699-.007.49.49 0 0 1 0-.701l4.764-4.735a.74.74 0 0 0 0-1.052.75.75 0 0 0-1.058 0L8.93 12.785a1.97 1.97 0 0 0 0 2.805c.781.777 2.038.78 2.816.007l5.126-5.094a3.206 3.206 0 0 0-.003-4.557 3.253 3.253 0 0 0-4.589.002l-5.466 5.433a4.45 4.45 0 0 0-.001 6.314 4.516 4.516 0 0 0 6.355-.004l5.113-5.081a.74.74 0 0 0 0-1.053.75.75 0 0 0-1.059 0"/></svg>`
    }, props));
$b1e33bf55e6e7a89$var$EditorAttachmentIcon.displayName = 'EditorAttachmentIcon';
var $b1e33bf55e6e7a89$var$_default = module.exports.default = $b1e33bf55e6e7a89$var$EditorAttachmentIcon;

});

parcelRegister("3KXjR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bc3ae9309768c41$var$_react = $2bc3ae9309768c41$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $2bc3ae9309768c41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bc3ae9309768c41$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $2bc3ae9309768c41$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props));
$2bc3ae9309768c41$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $2bc3ae9309768c41$var$_default = module.exports.default = $2bc3ae9309768c41$var$EditorBackgroundColorIcon;

});

parcelRegister("gPkH3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c40176090c7513d0$var$_react = $c40176090c7513d0$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $c40176090c7513d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c40176090c7513d0$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $c40176090c7513d0$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2"/></svg>`
    }, props));
$c40176090c7513d0$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $c40176090c7513d0$var$_default = module.exports.default = $c40176090c7513d0$var$EditorBulletListIcon;

});

parcelRegister("d0d2M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $977564ac4e77d5fb$var$_react = $977564ac4e77d5fb$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $977564ac4e77d5fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $977564ac4e77d5fb$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $977564ac4e77d5fb$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$977564ac4e77d5fb$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $977564ac4e77d5fb$var$_default = module.exports.default = $977564ac4e77d5fb$var$EditorCloseIcon;

});

parcelRegister("kG2Cm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0d9c2b9920aaf0e$var$_react = $f0d9c2b9920aaf0e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f0d9c2b9920aaf0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f0d9c2b9920aaf0e$var$EditorCodeIcon = (props)=>/*#__PURE__*/ $f0d9c2b9920aaf0e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.208 7.308a1.09 1.09 0 0 1 0 1.483l-3.515 3.71 3.515 3.708a1.09 1.09 0 0 1 0 1.483.957.957 0 0 1-1.405 0l-3.866-4.08a1.635 1.635 0 0 1 0-2.225l3.866-4.08a.957.957 0 0 1 1.405 0m3.584 0a.957.957 0 0 1 1.405 0l3.866 4.08c.583.614.583 1.61 0 2.225l-3.866 4.08a.957.957 0 0 1-1.405 0 1.09 1.09 0 0 1 0-1.484l3.515-3.708-3.515-3.71a1.09 1.09 0 0 1 0-1.483"/></svg>`
    }, props));
$f0d9c2b9920aaf0e$var$EditorCodeIcon.displayName = 'EditorCodeIcon';
var $f0d9c2b9920aaf0e$var$_default = module.exports.default = $f0d9c2b9920aaf0e$var$EditorCodeIcon;

});

parcelRegister("fvYtK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4b8aa130ff4eeeb$var$_react = $b4b8aa130ff4eeeb$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b4b8aa130ff4eeeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b4b8aa130ff4eeeb$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $b4b8aa130ff4eeeb$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
    }, props));
$b4b8aa130ff4eeeb$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $b4b8aa130ff4eeeb$var$_default = module.exports.default = $b4b8aa130ff4eeeb$var$EditorCollapseIcon;

});

parcelRegister("bmrnl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8456fbfa309860b0$var$_react = $8456fbfa309860b0$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $8456fbfa309860b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8456fbfa309860b0$var$EditorDateIcon = (props)=>/*#__PURE__*/ $8456fbfa309860b0$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8.51c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98c0 .282-.229.51-.5.51h-11a.505.505 0 0 1-.5-.51zm2 2.995v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 11h-.99a.497.497 0 0 0-.505.505m3 0v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99a.497.497 0 0 0-.505-.505h-.99a.497.497 0 0 0-.505.505m-3 3v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 14h-.99a.497.497 0 0 0-.505.505M7.5 8v1h3V8zm6 0v1h3V8zm.5-1.495c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505V8h-2zm-6 0C8 6.226 8.214 6 8.505 6h.99c.279 0 .505.214.505.505V8H8z"/></svg>`
    }, props));
$8456fbfa309860b0$var$EditorDateIcon.displayName = 'EditorDateIcon';
var $8456fbfa309860b0$var$_default = module.exports.default = $8456fbfa309860b0$var$EditorDateIcon;

});

parcelRegister("byKJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86a7202312ac53ac$var$_react = $86a7202312ac53ac$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $86a7202312ac53ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $86a7202312ac53ac$var$EditorEditIcon = (props)=>/*#__PURE__*/ $86a7202312ac53ac$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.148 6.852a.5.5 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367z"/></svg>`
    }, props));
$86a7202312ac53ac$var$EditorEditIcon.displayName = 'EditorEditIcon';
var $86a7202312ac53ac$var$_default = module.exports.default = $86a7202312ac53ac$var$EditorEditIcon;

});

parcelRegister("i6rUi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2de6f4940f4ffda$var$_react = $d2de6f4940f4ffda$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d2de6f4940f4ffda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d2de6f4940f4ffda$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $d2de6f4940f4ffda$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props));
$d2de6f4940f4ffda$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $d2de6f4940f4ffda$var$_default = module.exports.default = $d2de6f4940f4ffda$var$EditorEmojiIcon;

});

parcelRegister("dOtw2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0e6d7131ad5ef45$var$_react = $a0e6d7131ad5ef45$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $a0e6d7131ad5ef45$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a0e6d7131ad5ef45$var$EditorErrorIcon = (props)=>/*#__PURE__*/ $a0e6d7131ad5ef45$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.485 11.929 2.122-2.121a1 1 0 0 0-1.415-1.415l-2.12 2.122L9.95 8.393a1 1 0 0 0-1.414 1.415l2.12 2.12-2.12 2.122a1 1 0 0 0 1.414 1.414l2.121-2.12 2.121 2.12a1 1 0 1 0 1.415-1.414zM12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16"/></svg>`
    }, props));
$a0e6d7131ad5ef45$var$EditorErrorIcon.displayName = 'EditorErrorIcon';
var $a0e6d7131ad5ef45$var$_default = module.exports.default = $a0e6d7131ad5ef45$var$EditorErrorIcon;

});

parcelRegister("fKEXu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b77aec6c1a119d24$var$_react = $b77aec6c1a119d24$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b77aec6c1a119d24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b77aec6c1a119d24$var$EditorFilePreviewIcon = (props)=>/*#__PURE__*/ $b77aec6c1a119d24$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 18h3a1 1 0 0 1 0 2H6a2 2 0 0 1-2-2v-3a1 1 0 1 1 2 0zm12 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2M6 4h3a1 1 0 0 1 0 2H6v3a1 1 0 0 1-2 0V6a2 2 0 0 1 2-2m12 2h-3a1 1 0 1 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z" clip-rule="evenodd"/><path fill="currentcolor" d="m10.55 12.061-1.873.337a.998.998 0 0 1-.718-1.713 1 1 0 0 1 .718-.287h3.7c.316-.08.686.021.957.293.272.271.373.641.293.957v3.7a1 1 0 0 1-2 0l.337-1.873-2.602 2.603c-.345.344-.94.306-1.33-.084s-.429-.986-.084-1.33z"/></svg>`
    }, props));
$b77aec6c1a119d24$var$EditorFilePreviewIcon.displayName = 'EditorFilePreviewIcon';
var $b77aec6c1a119d24$var$_default = module.exports.default = $b77aec6c1a119d24$var$EditorFilePreviewIcon;

});

parcelRegister("l4ZyA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f589b899a9662523$var$_react = $f589b899a9662523$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f589b899a9662523$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f589b899a9662523$var$EditorHintIcon = (props)=>/*#__PURE__*/ $f589b899a9662523$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2m-4 1h4v1l-1.5 2h-1L10 18z"/></svg>`
    }, props));
$f589b899a9662523$var$EditorHintIcon.displayName = 'EditorHintIcon';
var $f589b899a9662523$var$_default = module.exports.default = $f589b899a9662523$var$EditorHintIcon;

});

parcelRegister("4NIhb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37ee1559ccc9d11d$var$_react = $37ee1559ccc9d11d$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $37ee1559ccc9d11d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $37ee1559ccc9d11d$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $37ee1559ccc9d11d$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props));
$37ee1559ccc9d11d$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $37ee1559ccc9d11d$var$_default = module.exports.default = $37ee1559ccc9d11d$var$EditorInfoIcon;

});

parcelRegister("i12BE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1da579165fe07be$var$_react = $d1da579165fe07be$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d1da579165fe07be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d1da579165fe07be$var$EditorLayoutThreeWithSidebarsIcon = (props)=>/*#__PURE__*/ $d1da579165fe07be$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 1 1 1v12a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1m4 0h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m10 0a1 1 0 0 1 1 1v12a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1"/></svg>`
    }, props));
$d1da579165fe07be$var$EditorLayoutThreeWithSidebarsIcon.displayName = 'EditorLayoutThreeWithSidebarsIcon';
var $d1da579165fe07be$var$_default = module.exports.default = $d1da579165fe07be$var$EditorLayoutThreeWithSidebarsIcon;

});

parcelRegister("7sUdD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56f6c1dc1b99ef35$var$_react = $56f6c1dc1b99ef35$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $56f6c1dc1b99ef35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $56f6c1dc1b99ef35$var$EditorLayoutTwoRightSidebarIcon = (props)=>/*#__PURE__*/ $56f6c1dc1b99ef35$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M5 5h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props));
$56f6c1dc1b99ef35$var$EditorLayoutTwoRightSidebarIcon.displayName = 'EditorLayoutTwoRightSidebarIcon';
var $56f6c1dc1b99ef35$var$_default = module.exports.default = $56f6c1dc1b99ef35$var$EditorLayoutTwoRightSidebarIcon;

});

parcelRegister("8IxMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $658ca2371b2e1812$var$_react = $658ca2371b2e1812$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $658ca2371b2e1812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $658ca2371b2e1812$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $658ca2371b2e1812$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props));
$658ca2371b2e1812$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $658ca2371b2e1812$var$_default = module.exports.default = $658ca2371b2e1812$var$EditorLinkIcon;

});

parcelRegister("h188A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c638d79cb46e3e3b$var$_react = $c638d79cb46e3e3b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $c638d79cb46e3e3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c638d79cb46e3e3b$var$EditorMediaWideIcon = (props)=>/*#__PURE__*/ $c638d79cb46e3e3b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 5h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 12h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
    }, props));
$c638d79cb46e3e3b$var$EditorMediaWideIcon.displayName = 'EditorMediaWideIcon';
var $c638d79cb46e3e3b$var$_default = module.exports.default = $c638d79cb46e3e3b$var$EditorMediaWideIcon;

});

parcelRegister("cSfLu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95f6c1c9256b04d6$var$_react = $95f6c1c9256b04d6$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95f6c1c9256b04d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95f6c1c9256b04d6$var$EditorOutdentIcon = (props)=>/*#__PURE__*/ $95f6c1c9256b04d6$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 9V7l-3 3 3 3v-2h2.51a.49.49 0 0 0 .49-.505v-.99A.495.495 0 0 0 11.51 9zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505z"/></svg>`
    }, props));
$95f6c1c9256b04d6$var$EditorOutdentIcon.displayName = 'EditorOutdentIcon';
var $95f6c1c9256b04d6$var$_default = module.exports.default = $95f6c1c9256b04d6$var$EditorOutdentIcon;

});

parcelRegister("5bJFE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c716817e39eb9b8$var$_react = $3c716817e39eb9b8$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3c716817e39eb9b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c716817e39eb9b8$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $3c716817e39eb9b8$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props));
$3c716817e39eb9b8$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $3c716817e39eb9b8$var$_default = module.exports.default = $3c716817e39eb9b8$var$EditorRemoveIcon;

});

parcelRegister("1hn1F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ee93d71c153d316$var$_react = $0ee93d71c153d316$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $0ee93d71c153d316$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0ee93d71c153d316$var$EditorRemoveEmojiIcon = (props)=>/*#__PURE__*/ $0ee93d71c153d316$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5.842 8.67a7 7 0 0 0 9.487 9.488l-1.12-1.121A5.5 5.5 0 0 1 12 17.5 5.506 5.506 0 0 1 6.5 12a5.5 5.5 0 0 1 .464-2.207zm11.195 5.539A5.5 5.5 0 0 0 17.5 12c0-3.033-2.467-5.5-5.5-5.5a5.5 5.5 0 0 0-2.207.464L8.67 5.842a7 7 0 0 1 9.487 9.487z" clip-rule="evenodd"/><rect width="1.75" height="19.976" x="4.319" y="5.556" fill="currentcolor" rx=".875" transform="rotate(-45 4.319 5.556)"/></svg>`
    }, props));
$0ee93d71c153d316$var$EditorRemoveEmojiIcon.displayName = 'EditorRemoveEmojiIcon';
var $0ee93d71c153d316$var$_default = module.exports.default = $0ee93d71c153d316$var$EditorRemoveEmojiIcon;

});

parcelRegister("6alL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47d48e1af62fdd7a$var$_react = $47d48e1af62fdd7a$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $47d48e1af62fdd7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47d48e1af62fdd7a$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $47d48e1af62fdd7a$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$47d48e1af62fdd7a$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $47d48e1af62fdd7a$var$_default = module.exports.default = $47d48e1af62fdd7a$var$EditorSuccessIcon;

});

parcelRegister("aNOf2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dd573ea1ed930e9$var$_react = $7dd573ea1ed930e9$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $7dd573ea1ed930e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7dd573ea1ed930e9$var$EditorTextStyleIcon = (props)=>/*#__PURE__*/ $7dd573ea1ed930e9$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m6.26 6.678-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678M7.736 8.08h.051l1.364 4.453H6.372zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404s-1.725.92-1.725 2.404c0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395"/></svg>`
    }, props));
$7dd573ea1ed930e9$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var $7dd573ea1ed930e9$var$_default = module.exports.default = $7dd573ea1ed930e9$var$EditorTextStyleIcon;

});

parcelRegister("bnpWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8485f65a8e30e992$var$_react = $8485f65a8e30e992$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $8485f65a8e30e992$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8485f65a8e30e992$var$EditorUnlinkIcon = (props)=>/*#__PURE__*/ $8485f65a8e30e992$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M5 10V9h2v1zm4-5h1v2H9zm7.646 12.354.708-.708 2 2-.708.708zM17 15v-1h2v1zm-3 2h1v2h-1zM7.354 6.646l-.708.708-2-2 .708-.708zm3.567 9.037 1.061-1.062a.75.75 0 1 1 1.06 1.061l-1.06 1.061a3.25 3.25 0 0 1-4.596 0 3.247 3.247 0 0 1 0-4.596l1.06-1.061.703-.703c.793-.63 1.773.35 1.06 1.06l-.702.703-1.06 1.062a1.747 1.747 0 0 0 0 2.474 1.75 1.75 0 0 0 2.474 0m2.658-7.608-1.061 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.062a3.25 3.25 0 0 1 4.596 0 3.247 3.247 0 0 1 0 4.596l-1.06 1.062-.703.702c-.565.565-1.581-.45-1.06-1.06l.702-.703 1.06-1.061a1.747 1.747 0 0 0 0-2.475 1.75 1.75 0 0 0-2.474 0"/></svg>`
    }, props));
$8485f65a8e30e992$var$EditorUnlinkIcon.displayName = 'EditorUnlinkIcon';
var $8485f65a8e30e992$var$_default = module.exports.default = $8485f65a8e30e992$var$EditorUnlinkIcon;

});

parcelRegister("5MbuW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a5ab36d5310e1$var$_react = $434a5ab36d5310e1$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $434a5ab36d5310e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $434a5ab36d5310e1$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $434a5ab36d5310e1$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props));
$434a5ab36d5310e1$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $434a5ab36d5310e1$var$_default = module.exports.default = $434a5ab36d5310e1$var$EditorWarningIcon;

});

parcelRegister("jc9Cb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df969899bdea9ad1$var$_react = $df969899bdea9ad1$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $df969899bdea9ad1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df969899bdea9ad1$var$EmailIcon = (props)=>/*#__PURE__*/ $df969899bdea9ad1$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props));
$df969899bdea9ad1$var$EmailIcon.displayName = 'EmailIcon';
var $df969899bdea9ad1$var$_default = module.exports.default = $df969899bdea9ad1$var$EmailIcon;

});

parcelRegister("kcmYy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb46c023c1eb0438$var$_react = $eb46c023c1eb0438$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $eb46c023c1eb0438$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb46c023c1eb0438$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $eb46c023c1eb0438$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
    }, props));
$eb46c023c1eb0438$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $eb46c023c1eb0438$var$_default = module.exports.default = $eb46c023c1eb0438$var$EmojiKeyboardIcon;

});

parcelRegister("8QILn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6715e713cda7fb94$var$_react = $6715e713cda7fb94$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $6715e713cda7fb94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6715e713cda7fb94$var$ErrorIcon = (props)=>/*#__PURE__*/ $6715e713cda7fb94$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$6715e713cda7fb94$var$ErrorIcon.displayName = 'ErrorIcon';
var $6715e713cda7fb94$var$_default = module.exports.default = $6715e713cda7fb94$var$ErrorIcon;

});

parcelRegister("3rvkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $281c3349a3aa0728$var$_react = $281c3349a3aa0728$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $281c3349a3aa0728$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $281c3349a3aa0728$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $281c3349a3aa0728$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props));
$281c3349a3aa0728$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $281c3349a3aa0728$var$_default = module.exports.default = $281c3349a3aa0728$var$HipchatChevronDownIcon;

});

parcelRegister("a7lwr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75db40b5bd5f37fc$var$_react = $75db40b5bd5f37fc$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $75db40b5bd5f37fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $75db40b5bd5f37fc$var$InfoIcon = (props)=>/*#__PURE__*/ $75db40b5bd5f37fc$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$75db40b5bd5f37fc$var$InfoIcon.displayName = 'InfoIcon';
var $75db40b5bd5f37fc$var$_default = module.exports.default = $75db40b5bd5f37fc$var$InfoIcon;

});

parcelRegister("kfDgS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebe3abc9c9b5c554$var$_react = $ebe3abc9c9b5c554$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $ebe3abc9c9b5c554$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ebe3abc9c9b5c554$var$LockIcon = (props)=>/*#__PURE__*/ $ebe3abc9c9b5c554$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$ebe3abc9c9b5c554$var$LockIcon.displayName = 'LockIcon';
var $ebe3abc9c9b5c554$var$_default = module.exports.default = $ebe3abc9c9b5c554$var$LockIcon;

});

parcelRegister("bJViO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c058bc88ad644c$var$_react = $88c058bc88ad644c$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $88c058bc88ad644c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88c058bc88ad644c$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $88c058bc88ad644c$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props));
$88c058bc88ad644c$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $88c058bc88ad644c$var$_default = module.exports.default = $88c058bc88ad644c$var$MediaServicesActualSizeIcon;

});

parcelRegister("8j0Ak", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60c08d3ac4428222$var$_react = $60c08d3ac4428222$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $60c08d3ac4428222$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $60c08d3ac4428222$var$MoreIcon = (props)=>/*#__PURE__*/ $60c08d3ac4428222$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props));
$60c08d3ac4428222$var$MoreIcon.displayName = 'MoreIcon';
var $60c08d3ac4428222$var$_default = module.exports.default = $60c08d3ac4428222$var$MoreIcon;

});

parcelRegister("h0sHG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c618b3b5bc08f93b$var$_react = $c618b3b5bc08f93b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $c618b3b5bc08f93b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c618b3b5bc08f93b$var$QuoteIcon = (props)=>/*#__PURE__*/ $c618b3b5bc08f93b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.051 6c-1.571 0-2.847 1.312-2.847 2.93 0 1.617 1.276 2.93 2.847 2.93 2.699 0 1.135 5.088-2.269 5.618a.68.68 0 0 0-.578.671c0 .416.372.745.784.682 6.187-.938 8.387-12.83 2.063-12.83M7.848 6C6.275 6 5 7.311 5 8.93c0 1.616 1.275 2.928 2.848 2.928 2.698 0 1.134 5.09-2.27 5.62a.68.68 0 0 0-.578.67c0 .416.372.745.783.682C11.972 17.892 14.172 6 7.848 6"/></svg>`
    }, props));
$c618b3b5bc08f93b$var$QuoteIcon.displayName = 'QuoteIcon';
var $c618b3b5bc08f93b$var$_default = module.exports.default = $c618b3b5bc08f93b$var$QuoteIcon;

});

parcelRegister("5NBJG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $438ecce33e921330$var$_react = $438ecce33e921330$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $438ecce33e921330$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $438ecce33e921330$var$SearchIcon = (props)=>/*#__PURE__*/ $438ecce33e921330$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props));
$438ecce33e921330$var$SearchIcon.displayName = 'SearchIcon';
var $438ecce33e921330$var$_default = module.exports.default = $438ecce33e921330$var$SearchIcon;

});

parcelRegister("kLlX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d939aafe67e92e$var$_react = $f1d939aafe67e92e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f1d939aafe67e92e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1d939aafe67e92e$var$UploadIcon = (props)=>/*#__PURE__*/ $f1d939aafe67e92e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props));
$f1d939aafe67e92e$var$UploadIcon.displayName = 'UploadIcon';
var $f1d939aafe67e92e$var$_default = module.exports.default = $f1d939aafe67e92e$var$UploadIcon;

});

parcelRegister("5Xi9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45608bda7050d4b8$var$_react = $45608bda7050d4b8$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $45608bda7050d4b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45608bda7050d4b8$var$WarningIcon = (props)=>/*#__PURE__*/ $45608bda7050d4b8$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$45608bda7050d4b8$var$WarningIcon.displayName = 'WarningIcon';
var $45608bda7050d4b8$var$_default = module.exports.default = $45608bda7050d4b8$var$WarningIcon;

});

parcelRegister("fzPWw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::155dbad4178295a8c00d95635f7ed7ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5726aaeb03339d1$var$_react = $b5726aaeb03339d1$var$_interopRequireDefault((parcelRequire("42omo")));

var $b5726aaeb03339d1$var$_alignTextLeft = $b5726aaeb03339d1$var$_interopRequireDefault((parcelRequire("6bJyJ")));

var $b5726aaeb03339d1$var$_alignLeft = $b5726aaeb03339d1$var$_interopRequireDefault((parcelRequire("iCiYs")));
function $b5726aaeb03339d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AlignTextLeftIcon.
 * This component is AlignTextLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorAlignLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5726aaeb03339d1$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $b5726aaeb03339d1$var$_react.default.createElement($b5726aaeb03339d1$var$_alignTextLeft.default, Object.assign({
        name: "AlignTextLeftIcon",
        LEGACY_fallbackIcon: $b5726aaeb03339d1$var$_alignLeft.default
    }, props));
$b5726aaeb03339d1$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIconMigration';
var $b5726aaeb03339d1$var$_default = module.exports.default = $b5726aaeb03339d1$var$AlignTextLeftIcon;

});

parcelRegister("7dWlC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7eac815f2299367efaa07c39203dac50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $542701f3bba412ba$var$_react = $542701f3bba412ba$var$_interopRequireDefault((parcelRequire("42omo")));

var $542701f3bba412ba$var$_alignTextRight = $542701f3bba412ba$var$_interopRequireDefault((parcelRequire("cOZT3")));

var $542701f3bba412ba$var$_alignRight = $542701f3bba412ba$var$_interopRequireDefault((parcelRequire("4EFIZ")));
function $542701f3bba412ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AlignTextRightIcon.
 * This component is AlignTextRightIcon, with `UNSAFE_fallbackIcon` set to "EditorAlignRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $542701f3bba412ba$var$AlignTextRightIcon = (props)=>/*#__PURE__*/ $542701f3bba412ba$var$_react.default.createElement($542701f3bba412ba$var$_alignTextRight.default, Object.assign({
        name: "AlignTextRightIcon",
        LEGACY_fallbackIcon: $542701f3bba412ba$var$_alignRight.default
    }, props));
$542701f3bba412ba$var$AlignTextRightIcon.displayName = 'AlignTextRightIconMigration';
var $542701f3bba412ba$var$_default = module.exports.default = $542701f3bba412ba$var$AlignTextRightIcon;

});

parcelRegister("8Y8Qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $687ac941c1cb4bff$var$_react = $687ac941c1cb4bff$var$_interopRequireDefault((parcelRequire("42omo")));

var $687ac941c1cb4bff$var$_statusSuccess = $687ac941c1cb4bff$var$_interopRequireDefault((parcelRequire("3sFtD")));

var $687ac941c1cb4bff$var$_checkCircle = $687ac941c1cb4bff$var$_interopRequireDefault((parcelRequire("eCByP")));
function $687ac941c1cb4bff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $687ac941c1cb4bff$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $687ac941c1cb4bff$var$_react.default.createElement($687ac941c1cb4bff$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $687ac941c1cb4bff$var$_checkCircle.default
    }, props));
$687ac941c1cb4bff$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $687ac941c1cb4bff$var$_default = module.exports.default = $687ac941c1cb4bff$var$StatusSuccessIcon;

});

parcelRegister("lh5eH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119fcb233ad7d2568bcc63888dfec4d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7cf3f4a326719e1$var$_react = $f7cf3f4a326719e1$var$_interopRequireDefault((parcelRequire("42omo")));

var $f7cf3f4a326719e1$var$_chevronDown = $f7cf3f4a326719e1$var$_interopRequireDefault((parcelRequire("ghftu")));

var $f7cf3f4a326719e1$var$_chevronDown2 = $f7cf3f4a326719e1$var$_interopRequireDefault((parcelRequire("3rvkR")));
function $f7cf3f4a326719e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7cf3f4a326719e1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f7cf3f4a326719e1$var$_react.default.createElement($f7cf3f4a326719e1$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $f7cf3f4a326719e1$var$_chevronDown2.default
    }, props));
$f7cf3f4a326719e1$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $f7cf3f4a326719e1$var$_default = module.exports.default = $f7cf3f4a326719e1$var$ChevronDownIcon;

});

parcelRegister("ghftu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd9a3cd17c99332c$var$_react = $bd9a3cd17c99332c$var$_interopRequireDefault((parcelRequire("42omo")));

var $bd9a3cd17c99332c$var$_baseNew = $bd9a3cd17c99332c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bd9a3cd17c99332c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd9a3cd17c99332c$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $bd9a3cd17c99332c$var$_react.default.createElement($bd9a3cd17c99332c$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$bd9a3cd17c99332c$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $bd9a3cd17c99332c$var$_default = module.exports.default = $bd9a3cd17c99332c$var$ChevronDownIcon;

});

parcelRegister("dVtAn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4aaa99e30c6c75833f1e95013ae6432f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2378c51ba237dfc$var$_react = $a2378c51ba237dfc$var$_interopRequireDefault((parcelRequire("42omo")));

var $a2378c51ba237dfc$var$_chevronRight = $a2378c51ba237dfc$var$_interopRequireDefault((parcelRequire("6R5uz")));

var $a2378c51ba237dfc$var$_chevronRightCircle = $a2378c51ba237dfc$var$_interopRequireDefault((parcelRequire("eowPm")));
function $a2378c51ba237dfc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2378c51ba237dfc$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $a2378c51ba237dfc$var$_react.default.createElement($a2378c51ba237dfc$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $a2378c51ba237dfc$var$_chevronRightCircle.default
    }, props));
$a2378c51ba237dfc$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $a2378c51ba237dfc$var$_default = module.exports.default = $a2378c51ba237dfc$var$ChevronRightIcon;

});

parcelRegister("hNEaN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb3eee7b92db2782a45444d8dbb123a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf562ccc4c791e7c$var$_react = $cf562ccc4c791e7c$var$_interopRequireDefault((parcelRequire("42omo")));

var $cf562ccc4c791e7c$var$_chevronRight = $cf562ccc4c791e7c$var$_interopRequireDefault((parcelRequire("6R5uz")));

var $cf562ccc4c791e7c$var$_chevronRightLarge = $cf562ccc4c791e7c$var$_interopRequireDefault((parcelRequire("dskUg")));
function $cf562ccc4c791e7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf562ccc4c791e7c$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $cf562ccc4c791e7c$var$_react.default.createElement($cf562ccc4c791e7c$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $cf562ccc4c791e7c$var$_chevronRightLarge.default
    }, props));
$cf562ccc4c791e7c$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $cf562ccc4c791e7c$var$_default = module.exports.default = $cf562ccc4c791e7c$var$ChevronRightIcon;

});

parcelRegister("94rSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::490c6ba7253b268fa0e3126a77316ea8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69aa1cae5c0d69bf$var$_react = $69aa1cae5c0d69bf$var$_interopRequireDefault((parcelRequire("42omo")));

var $69aa1cae5c0d69bf$var$_attachment = $69aa1cae5c0d69bf$var$_interopRequireDefault((parcelRequire("9lz2c")));

var $69aa1cae5c0d69bf$var$_attachment2 = $69aa1cae5c0d69bf$var$_interopRequireDefault((parcelRequire("fgThH")));
function $69aa1cae5c0d69bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AttachmentIcon.
 * This component is AttachmentIcon, with `UNSAFE_fallbackIcon` set to "EditorAttachmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69aa1cae5c0d69bf$var$AttachmentIcon = (props)=>/*#__PURE__*/ $69aa1cae5c0d69bf$var$_react.default.createElement($69aa1cae5c0d69bf$var$_attachment.default, Object.assign({
        name: "AttachmentIcon",
        LEGACY_fallbackIcon: $69aa1cae5c0d69bf$var$_attachment2.default
    }, props));
$69aa1cae5c0d69bf$var$AttachmentIcon.displayName = 'AttachmentIconMigration';
var $69aa1cae5c0d69bf$var$_default = module.exports.default = $69aa1cae5c0d69bf$var$AttachmentIcon;

});

parcelRegister("9lz2c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1df8f3604b71bb3b07e9fa53eb6c9031>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ce1405572307310$var$_react = $6ce1405572307310$var$_interopRequireDefault((parcelRequire("42omo")));

var $6ce1405572307310$var$_baseNew = $6ce1405572307310$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6ce1405572307310$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ce1405572307310$var$AttachmentIcon = (props)=>/*#__PURE__*/ $6ce1405572307310$var$_react.default.createElement($6ce1405572307310$var$_baseNew.default, Object.assign({
        name: "AttachmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$6ce1405572307310$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $6ce1405572307310$var$_default = module.exports.default = $6ce1405572307310$var$AttachmentIcon;

});

parcelRegister("gNtj9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5db26519e9813775db7effa65e775e41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3a7f4e7daa0a48a$var$_react = $c3a7f4e7daa0a48a$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3a7f4e7daa0a48a$var$_listBulleted = $c3a7f4e7daa0a48a$var$_interopRequireDefault((parcelRequire("cUQMr")));

var $c3a7f4e7daa0a48a$var$_bulletList = $c3a7f4e7daa0a48a$var$_interopRequireDefault((parcelRequire("gPkH3")));
function $c3a7f4e7daa0a48a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "EditorBulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3a7f4e7daa0a48a$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $c3a7f4e7daa0a48a$var$_react.default.createElement($c3a7f4e7daa0a48a$var$_listBulleted.default, Object.assign({
        name: "ListBulletedIcon",
        LEGACY_fallbackIcon: $c3a7f4e7daa0a48a$var$_bulletList.default
    }, props));
$c3a7f4e7daa0a48a$var$ListBulletedIcon.displayName = 'ListBulletedIconMigration';
var $c3a7f4e7daa0a48a$var$_default = module.exports.default = $c3a7f4e7daa0a48a$var$ListBulletedIcon;

});

parcelRegister("f9qTu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c81a0c746dcbf555f1d7184c12edaec5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b07c8edc7d422f5f$var$_react = $b07c8edc7d422f5f$var$_interopRequireDefault((parcelRequire("42omo")));

var $b07c8edc7d422f5f$var$_shrinkHorizontal = $b07c8edc7d422f5f$var$_interopRequireDefault((parcelRequire("64M9v")));

var $b07c8edc7d422f5f$var$_collapse = $b07c8edc7d422f5f$var$_interopRequireDefault((parcelRequire("fvYtK")));
function $b07c8edc7d422f5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkHorizontalIcon.
 * This component is ShrinkHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorCollapseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b07c8edc7d422f5f$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $b07c8edc7d422f5f$var$_react.default.createElement($b07c8edc7d422f5f$var$_shrinkHorizontal.default, Object.assign({
        name: "ShrinkHorizontalIcon",
        LEGACY_fallbackIcon: $b07c8edc7d422f5f$var$_collapse.default
    }, props));
$b07c8edc7d422f5f$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIconMigration';
var $b07c8edc7d422f5f$var$_default = module.exports.default = $b07c8edc7d422f5f$var$ShrinkHorizontalIcon;

});

parcelRegister("64M9v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fe612b077f89273578622d0011caa3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46c877d9e4f2db1d$var$_react = $46c877d9e4f2db1d$var$_interopRequireDefault((parcelRequire("42omo")));

var $46c877d9e4f2db1d$var$_baseNew = $46c877d9e4f2db1d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $46c877d9e4f2db1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46c877d9e4f2db1d$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $46c877d9e4f2db1d$var$_react.default.createElement($46c877d9e4f2db1d$var$_baseNew.default, Object.assign({
        name: "ShrinkHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$46c877d9e4f2db1d$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $46c877d9e4f2db1d$var$_default = module.exports.default = $46c877d9e4f2db1d$var$ShrinkHorizontalIcon;

});

parcelRegister("2K1WS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::436df245fce6d8a4ae638488bb1b0701>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ff1639eada8118e$var$_react = $1ff1639eada8118e$var$_interopRequireDefault((parcelRequire("42omo")));

var $1ff1639eada8118e$var$_edit = $1ff1639eada8118e$var$_interopRequireDefault((parcelRequire("1Zr9M")));

var $1ff1639eada8118e$var$_edit2 = $1ff1639eada8118e$var$_interopRequireDefault((parcelRequire("byKJT")));
function $1ff1639eada8118e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditorEditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ff1639eada8118e$var$EditIcon = (props)=>/*#__PURE__*/ $1ff1639eada8118e$var$_react.default.createElement($1ff1639eada8118e$var$_edit.default, Object.assign({
        name: "EditIcon",
        LEGACY_fallbackIcon: $1ff1639eada8118e$var$_edit2.default
    }, props));
$1ff1639eada8118e$var$EditIcon.displayName = 'EditIconMigration';
var $1ff1639eada8118e$var$_default = module.exports.default = $1ff1639eada8118e$var$EditIcon;

});

parcelRegister("1Zr9M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ac376f9836d1894f72051899adf679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17308db967ef8257$var$_react = $17308db967ef8257$var$_interopRequireDefault((parcelRequire("42omo")));

var $17308db967ef8257$var$_baseNew = $17308db967ef8257$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17308db967ef8257$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17308db967ef8257$var$EditIcon = (props)=>/*#__PURE__*/ $17308db967ef8257$var$_react.default.createElement($17308db967ef8257$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$17308db967ef8257$var$EditIcon.displayName = 'EditIcon';
var $17308db967ef8257$var$_default = module.exports.default = $17308db967ef8257$var$EditIcon;

});

parcelRegister("bha8O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e8903c281175d8bcf886425acfa2d3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8359260c849c7f61$var$_react = $8359260c849c7f61$var$_interopRequireDefault((parcelRequire("42omo")));

var $8359260c849c7f61$var$_file = $8359260c849c7f61$var$_interopRequireDefault((parcelRequire("chO1Z")));

var $8359260c849c7f61$var$_file2 = $8359260c849c7f61$var$_interopRequireDefault((parcelRequire("fEmHe")));
function $8359260c849c7f61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "EditorFileIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8359260c849c7f61$var$FileIcon = (props)=>/*#__PURE__*/ $8359260c849c7f61$var$_react.default.createElement($8359260c849c7f61$var$_file.default, Object.assign({
        name: "FileIcon",
        LEGACY_fallbackIcon: $8359260c849c7f61$var$_file2.default
    }, props));
$8359260c849c7f61$var$FileIcon.displayName = 'FileIconMigration';
var $8359260c849c7f61$var$_default = module.exports.default = $8359260c849c7f61$var$FileIcon;

});

parcelRegister("bzy7z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f3aefae583a022abe386e582aacff41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86cd6e59822cd819$var$_react = $86cd6e59822cd819$var$_interopRequireDefault((parcelRequire("42omo")));

var $86cd6e59822cd819$var$_lightbulb = $86cd6e59822cd819$var$_interopRequireDefault((parcelRequire("3HOqx")));

var $86cd6e59822cd819$var$_hint = $86cd6e59822cd819$var$_interopRequireDefault((parcelRequire("l4ZyA")));
function $86cd6e59822cd819$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "EditorHintIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86cd6e59822cd819$var$LightbulbIcon = (props)=>/*#__PURE__*/ $86cd6e59822cd819$var$_react.default.createElement($86cd6e59822cd819$var$_lightbulb.default, Object.assign({
        name: "LightbulbIcon",
        LEGACY_fallbackIcon: $86cd6e59822cd819$var$_hint.default
    }, props));
$86cd6e59822cd819$var$LightbulbIcon.displayName = 'LightbulbIconMigration';
var $86cd6e59822cd819$var$_default = module.exports.default = $86cd6e59822cd819$var$LightbulbIcon;

});

parcelRegister("3HOqx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::987f1732135eba9300239393b5450485>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b2c81054261ff66$var$_react = $2b2c81054261ff66$var$_interopRequireDefault((parcelRequire("42omo")));

var $2b2c81054261ff66$var$_baseNew = $2b2c81054261ff66$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2b2c81054261ff66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b2c81054261ff66$var$LightbulbIcon = (props)=>/*#__PURE__*/ $2b2c81054261ff66$var$_react.default.createElement($2b2c81054261ff66$var$_baseNew.default, Object.assign({
        name: "LightbulbIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$2b2c81054261ff66$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $2b2c81054261ff66$var$_default = module.exports.default = $2b2c81054261ff66$var$LightbulbIcon;

});

parcelRegister("6fpJf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b83cd234d5712d22c639f33aef110659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48c819f912dea902$var$_react = $48c819f912dea902$var$_interopRequireDefault((parcelRequire("42omo")));

var $48c819f912dea902$var$_image = $48c819f912dea902$var$_interopRequireDefault((parcelRequire("fZtQj")));

var $48c819f912dea902$var$_image2 = $48c819f912dea902$var$_interopRequireDefault((parcelRequire("glU04")));
function $48c819f912dea902$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ImageIcon.
 * This component is ImageIcon, with `UNSAFE_fallbackIcon` set to "EditorImageIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48c819f912dea902$var$ImageIcon = (props)=>/*#__PURE__*/ $48c819f912dea902$var$_react.default.createElement($48c819f912dea902$var$_image.default, Object.assign({
        name: "ImageIcon",
        LEGACY_fallbackIcon: $48c819f912dea902$var$_image2.default
    }, props));
$48c819f912dea902$var$ImageIcon.displayName = 'ImageIconMigration';
var $48c819f912dea902$var$_default = module.exports.default = $48c819f912dea902$var$ImageIcon;

});

parcelRegister("85Ln8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5444b51e487d7ee30ba43f31750651c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e4389815cedd70f$var$_react = $5e4389815cedd70f$var$_interopRequireDefault((parcelRequire("42omo")));

var $5e4389815cedd70f$var$_textItalic = $5e4389815cedd70f$var$_interopRequireDefault((parcelRequire("2gUVF")));

var $5e4389815cedd70f$var$_italic = $5e4389815cedd70f$var$_interopRequireDefault((parcelRequire("4AGyV")));
function $5e4389815cedd70f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextItalicIcon.
 * This component is TextItalicIcon, with `UNSAFE_fallbackIcon` set to "EditorItalicIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e4389815cedd70f$var$TextItalicIcon = (props)=>/*#__PURE__*/ $5e4389815cedd70f$var$_react.default.createElement($5e4389815cedd70f$var$_textItalic.default, Object.assign({
        name: "TextItalicIcon",
        LEGACY_fallbackIcon: $5e4389815cedd70f$var$_italic.default
    }, props));
$5e4389815cedd70f$var$TextItalicIcon.displayName = 'TextItalicIconMigration';
var $5e4389815cedd70f$var$_default = module.exports.default = $5e4389815cedd70f$var$TextItalicIcon;

});

parcelRegister("2I7Ze", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c15f4189326bd2e6492a7d035d5fa7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f95e2d1f6fad9da$var$_react = $1f95e2d1f6fad9da$var$_interopRequireDefault((parcelRequire("42omo")));

var $1f95e2d1f6fad9da$var$_layoutOneColumn = $1f95e2d1f6fad9da$var$_interopRequireDefault((parcelRequire("bmsMK")));

var $1f95e2d1f6fad9da$var$_layoutSingle = $1f95e2d1f6fad9da$var$_interopRequireDefault((parcelRequire("31Ui6")));
function $1f95e2d1f6fad9da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutOneColumnIcon.
 * This component is LayoutOneColumnIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutSingleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f95e2d1f6fad9da$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $1f95e2d1f6fad9da$var$_react.default.createElement($1f95e2d1f6fad9da$var$_layoutOneColumn.default, Object.assign({
        name: "LayoutOneColumnIcon",
        LEGACY_fallbackIcon: $1f95e2d1f6fad9da$var$_layoutSingle.default
    }, props));
$1f95e2d1f6fad9da$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIconMigration';
var $1f95e2d1f6fad9da$var$_default = module.exports.default = $1f95e2d1f6fad9da$var$LayoutOneColumnIcon;

});

parcelRegister("hdbFN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ebc5584527a2da6ee43e6525369babd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c87cb495766f35a7$var$_react = $c87cb495766f35a7$var$_interopRequireDefault((parcelRequire("42omo")));

var $c87cb495766f35a7$var$_layoutThreeColumnsSidebars = $c87cb495766f35a7$var$_interopRequireDefault((parcelRequire("5NtbR")));

var $c87cb495766f35a7$var$_layoutThreeWithSidebars = $c87cb495766f35a7$var$_interopRequireDefault((parcelRequire("i12BE")));
function $c87cb495766f35a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutThreeColumnsSidebarsIcon.
 * This component is LayoutThreeColumnsSidebarsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutThreeWithSidebarsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c87cb495766f35a7$var$LayoutThreeColumnsSidebarsIcon = (props)=>/*#__PURE__*/ $c87cb495766f35a7$var$_react.default.createElement($c87cb495766f35a7$var$_layoutThreeColumnsSidebars.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsIcon",
        LEGACY_fallbackIcon: $c87cb495766f35a7$var$_layoutThreeWithSidebars.default
    }, props));
$c87cb495766f35a7$var$LayoutThreeColumnsSidebarsIcon.displayName = 'LayoutThreeColumnsSidebarsIconMigration';
var $c87cb495766f35a7$var$_default = module.exports.default = $c87cb495766f35a7$var$LayoutThreeColumnsSidebarsIcon;

});

parcelRegister("5NtbR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::314560a3eae62141d1d45d3625a6de50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43882beaa73d1088$var$_react = $43882beaa73d1088$var$_interopRequireDefault((parcelRequire("42omo")));

var $43882beaa73d1088$var$_baseNew = $43882beaa73d1088$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $43882beaa73d1088$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebars".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43882beaa73d1088$var$LayoutThreeColumnsSidebarsIcon = (props)=>/*#__PURE__*/ $43882beaa73d1088$var$_react.default.createElement($43882beaa73d1088$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h3.25C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 15 5 14.384 5 13.625zm1.5.125v11h3v-11zm6-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$43882beaa73d1088$var$LayoutThreeColumnsSidebarsIcon.displayName = 'LayoutThreeColumnsSidebarsIcon';
var $43882beaa73d1088$var$_default = module.exports.default = $43882beaa73d1088$var$LayoutThreeColumnsSidebarsIcon;

});

parcelRegister("hIlvQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4571b7e70ca52e55dc3b5128ce36d6f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce573bb32a8bbecd$var$_react = $ce573bb32a8bbecd$var$_interopRequireDefault((parcelRequire("42omo")));

var $ce573bb32a8bbecd$var$_layoutTwoColumns = $ce573bb32a8bbecd$var$_interopRequireDefault((parcelRequire("asgOl")));

var $ce573bb32a8bbecd$var$_layoutTwoEqual = $ce573bb32a8bbecd$var$_interopRequireDefault((parcelRequire("9HSvn")));
function $ce573bb32a8bbecd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsIcon.
 * This component is LayoutTwoColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce573bb32a8bbecd$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $ce573bb32a8bbecd$var$_react.default.createElement($ce573bb32a8bbecd$var$_layoutTwoColumns.default, Object.assign({
        name: "LayoutTwoColumnsIcon",
        LEGACY_fallbackIcon: $ce573bb32a8bbecd$var$_layoutTwoEqual.default
    }, props));
$ce573bb32a8bbecd$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIconMigration';
var $ce573bb32a8bbecd$var$_default = module.exports.default = $ce573bb32a8bbecd$var$LayoutTwoColumnsIcon;

});

parcelRegister("hXbEU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8415696cbc2266afa6adea59e7b1e67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d120fd8cdad97267$var$_react = $d120fd8cdad97267$var$_interopRequireDefault((parcelRequire("42omo")));

var $d120fd8cdad97267$var$_layoutTwoColumnsSidebarLeft = $d120fd8cdad97267$var$_interopRequireDefault((parcelRequire("e0qVa")));

var $d120fd8cdad97267$var$_layoutTwoLeftSidebar = $d120fd8cdad97267$var$_interopRequireDefault((parcelRequire("fBY8v")));
function $d120fd8cdad97267$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsSidebarLeftIcon.
 * This component is LayoutTwoColumnsSidebarLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoLeftSidebarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d120fd8cdad97267$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $d120fd8cdad97267$var$_react.default.createElement($d120fd8cdad97267$var$_layoutTwoColumnsSidebarLeft.default, Object.assign({
        name: "LayoutTwoColumnsSidebarLeftIcon",
        LEGACY_fallbackIcon: $d120fd8cdad97267$var$_layoutTwoLeftSidebar.default
    }, props));
$d120fd8cdad97267$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIconMigration';
var $d120fd8cdad97267$var$_default = module.exports.default = $d120fd8cdad97267$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("11w2e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7e8af757eae9bbc8243694d5d6aa229>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0beebbee841d82d1$var$_react = $0beebbee841d82d1$var$_interopRequireDefault((parcelRequire("42omo")));

var $0beebbee841d82d1$var$_expandHorizontal = $0beebbee841d82d1$var$_interopRequireDefault((parcelRequire("gzsfl")));

var $0beebbee841d82d1$var$_mediaFullWidth = $0beebbee841d82d1$var$_interopRequireDefault((parcelRequire("bWDfG")));
function $0beebbee841d82d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ExpandHorizontalIcon.
 * This component is ExpandHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMediaFullWidthIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0beebbee841d82d1$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $0beebbee841d82d1$var$_react.default.createElement($0beebbee841d82d1$var$_expandHorizontal.default, Object.assign({
        name: "ExpandHorizontalIcon",
        LEGACY_fallbackIcon: $0beebbee841d82d1$var$_mediaFullWidth.default
    }, props));
$0beebbee841d82d1$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIconMigration';
var $0beebbee841d82d1$var$_default = module.exports.default = $0beebbee841d82d1$var$ExpandHorizontalIcon;

});

parcelRegister("gzsfl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5756fa661fb64df215b386b689bcf117>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c105d36702cd9305$var$_react = $c105d36702cd9305$var$_interopRequireDefault((parcelRequire("42omo")));

var $c105d36702cd9305$var$_baseNew = $c105d36702cd9305$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c105d36702cd9305$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c105d36702cd9305$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $c105d36702cd9305$var$_react.default.createElement($c105d36702cd9305$var$_baseNew.default, Object.assign({
        name: "ExpandHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 1v14H0V1zM16 1v14h-1.5V1zm-1.72 6.47a.75.75 0 0 1 0 1.06l-3.25 3.25-1.06-1.06 1.97-1.97H4.06l1.97 1.97-1.06 1.06-3.25-3.25a.75.75 0 0 1 0-1.06l3.25-3.25 1.06 1.06-1.97 1.97h7.88L9.97 5.28l1.06-1.06z"/>`
    }, props));
$c105d36702cd9305$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $c105d36702cd9305$var$_default = module.exports.default = $c105d36702cd9305$var$ExpandHorizontalIcon;

});

parcelRegister("97auY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b2a624ab48588b86283eda190f93753>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a2ce95399b77899$var$_react = $6a2ce95399b77899$var$_interopRequireDefault((parcelRequire("42omo")));

var $6a2ce95399b77899$var$_contentWidthWide = $6a2ce95399b77899$var$_interopRequireDefault((parcelRequire("kDG8M")));

var $6a2ce95399b77899$var$_mediaWide = $6a2ce95399b77899$var$_interopRequireDefault((parcelRequire("h188A")));
function $6a2ce95399b77899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ContentWidthWideIcon.
 * This component is ContentWidthWideIcon, with `UNSAFE_fallbackIcon` set to "EditorMediaWideIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a2ce95399b77899$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $6a2ce95399b77899$var$_react.default.createElement($6a2ce95399b77899$var$_contentWidthWide.default, Object.assign({
        name: "ContentWidthWideIcon",
        LEGACY_fallbackIcon: $6a2ce95399b77899$var$_mediaWide.default
    }, props));
$6a2ce95399b77899$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIconMigration';
var $6a2ce95399b77899$var$_default = module.exports.default = $6a2ce95399b77899$var$ContentWidthWideIcon;

});

parcelRegister("kDG8M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a65ef02b42df957b8012c4998bb403f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0682367c41faa8d$var$_react = $f0682367c41faa8d$var$_interopRequireDefault((parcelRequire("42omo")));

var $f0682367c41faa8d$var$_baseNew = $f0682367c41faa8d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f0682367c41faa8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0682367c41faa8d$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $f0682367c41faa8d$var$_react.default.createElement($f0682367c41faa8d$var$_baseNew.default, Object.assign({
        name: "ContentWidthWideIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5H4V1h8zm-10.5 3v5h13v-5zM1.375 4h13.25C15.385 4 16 4.616 16 5.375v5.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 12 0 11.384 0 10.625v-5.25C0 4.615.616 4 1.375 4M12 15H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$f0682367c41faa8d$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $f0682367c41faa8d$var$_default = module.exports.default = $f0682367c41faa8d$var$ContentWidthWideIcon;

});

parcelRegister("bfMUY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6037f83b84c7668cea5207d550175115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83170a856633fdd7$var$_react = $83170a856633fdd7$var$_interopRequireDefault((parcelRequire("42omo")));

var $83170a856633fdd7$var$_listNumbered = $83170a856633fdd7$var$_interopRequireDefault((parcelRequire("2y4tz")));

var $83170a856633fdd7$var$_numberList = $83170a856633fdd7$var$_interopRequireDefault((parcelRequire("dGf3x")));
function $83170a856633fdd7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListNumberedIcon.
 * This component is ListNumberedIcon, with `UNSAFE_fallbackIcon` set to "EditorNumberListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83170a856633fdd7$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $83170a856633fdd7$var$_react.default.createElement($83170a856633fdd7$var$_listNumbered.default, Object.assign({
        name: "ListNumberedIcon",
        LEGACY_fallbackIcon: $83170a856633fdd7$var$_numberList.default
    }, props));
$83170a856633fdd7$var$ListNumberedIcon.displayName = 'ListNumberedIconMigration';
var $83170a856633fdd7$var$_default = module.exports.default = $83170a856633fdd7$var$ListNumberedIcon;

});

parcelRegister("2y4tz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f7654718483868ec656fda28b5f1426>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1db23a990eaaba71$var$_react = $1db23a990eaaba71$var$_interopRequireDefault((parcelRequire("42omo")));

var $1db23a990eaaba71$var$_baseNew = $1db23a990eaaba71$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1db23a990eaaba71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1db23a990eaaba71$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $1db23a990eaaba71$var$_react.default.createElement($1db23a990eaaba71$var$_baseNew.default, Object.assign({
        name: "ListNumberedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 5H6V3.5h10zm0 7.5H6V11h10zM.5 1h1.75a.75.75 0 0 1 .75.75V7H1.5V2.5h-1zM0 8.5h2.63C3.39 8.5 4 9.12 4 9.88v1.25c0 .76-.62 1.38-1.37 1.38H1.5v1H4V15H.75a.75.75 0 0 1-.75-.75v-1.87C0 11.62.62 11 1.38 11H2.5v-1H0z" clip-rule="evenodd"/>`
    }, props));
$1db23a990eaaba71$var$ListNumberedIcon.displayName = 'ListNumberedIcon';
var $1db23a990eaaba71$var$_default = module.exports.default = $1db23a990eaaba71$var$ListNumberedIcon;

});

parcelRegister("9d81r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be95c47a86ba406b4074b195e08f177d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b4b8d03b57c8bad$var$_react = $6b4b8d03b57c8bad$var$_interopRequireDefault((parcelRequire("42omo")));

var $6b4b8d03b57c8bad$var$_statusInformation = $6b4b8d03b57c8bad$var$_interopRequireDefault((parcelRequire("eXmBZ")));

var $6b4b8d03b57c8bad$var$_panel = $6b4b8d03b57c8bad$var$_interopRequireDefault((parcelRequire("gmTTR")));
function $6b4b8d03b57c8bad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b4b8d03b57c8bad$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $6b4b8d03b57c8bad$var$_react.default.createElement($6b4b8d03b57c8bad$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $6b4b8d03b57c8bad$var$_panel.default
    }, props));
$6b4b8d03b57c8bad$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $6b4b8d03b57c8bad$var$_default = module.exports.default = $6b4b8d03b57c8bad$var$StatusInformationIcon;

});

parcelRegister("hJIZ7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60832bf0895f3f62571fae1dfe0965a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce9988acc2b44748$var$_react = $ce9988acc2b44748$var$_interopRequireDefault((parcelRequire("42omo")));

var $ce9988acc2b44748$var$_delete = $ce9988acc2b44748$var$_interopRequireDefault((parcelRequire("gKvd9")));

var $ce9988acc2b44748$var$_remove = $ce9988acc2b44748$var$_interopRequireDefault((parcelRequire("5bJFE")));
function $ce9988acc2b44748$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce9988acc2b44748$var$DeleteIcon = (props)=>/*#__PURE__*/ $ce9988acc2b44748$var$_react.default.createElement($ce9988acc2b44748$var$_delete.default, Object.assign({
        name: "DeleteIcon",
        LEGACY_fallbackIcon: $ce9988acc2b44748$var$_remove.default
    }, props));
$ce9988acc2b44748$var$DeleteIcon.displayName = 'DeleteIconMigration';
var $ce9988acc2b44748$var$_default = module.exports.default = $ce9988acc2b44748$var$DeleteIcon;

});

parcelRegister("gKvd9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8e09626672d9215bf80d7cf3a8d93a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3192713330dc291$var$_react = $c3192713330dc291$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3192713330dc291$var$_baseNew = $c3192713330dc291$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3192713330dc291$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3192713330dc291$var$DeleteIcon = (props)=>/*#__PURE__*/ $c3192713330dc291$var$_react.default.createElement($c3192713330dc291$var$_baseNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$c3192713330dc291$var$DeleteIcon.displayName = 'DeleteIcon';
var $c3192713330dc291$var$_default = module.exports.default = $c3192713330dc291$var$DeleteIcon;

});

parcelRegister("1F7NQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2d61a8b9264c17f51d6b1ce92a21fc9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $135fac4525613629$var$_react = $135fac4525613629$var$_interopRequireDefault((parcelRequire("42omo")));

var $135fac4525613629$var$_search = $135fac4525613629$var$_interopRequireDefault((parcelRequire("jluld")));

var $135fac4525613629$var$_search2 = $135fac4525613629$var$_interopRequireDefault((parcelRequire("66gZz")));
function $135fac4525613629$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $135fac4525613629$var$SearchIcon = (props)=>/*#__PURE__*/ $135fac4525613629$var$_react.default.createElement($135fac4525613629$var$_search.default, Object.assign({
        name: "SearchIcon",
        LEGACY_fallbackIcon: $135fac4525613629$var$_search2.default
    }, props));
$135fac4525613629$var$SearchIcon.displayName = 'SearchIconMigration';
var $135fac4525613629$var$_default = module.exports.default = $135fac4525613629$var$SearchIcon;

});

parcelRegister("jRCDI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3fc694d3fb7f34372832d6a419d8bc29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e760f08ed9817a42$var$_react = $e760f08ed9817a42$var$_interopRequireDefault((parcelRequire("42omo")));

var $e760f08ed9817a42$var$_settings = $e760f08ed9817a42$var$_interopRequireDefault((parcelRequire("fIcbd")));

var $e760f08ed9817a42$var$_settings2 = $e760f08ed9817a42$var$_interopRequireDefault((parcelRequire("a6h9M")));
function $e760f08ed9817a42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "EditorSettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e760f08ed9817a42$var$SettingsIcon = (props)=>/*#__PURE__*/ $e760f08ed9817a42$var$_react.default.createElement($e760f08ed9817a42$var$_settings.default, Object.assign({
        name: "SettingsIcon",
        LEGACY_fallbackIcon: $e760f08ed9817a42$var$_settings2.default
    }, props));
$e760f08ed9817a42$var$SettingsIcon.displayName = 'SettingsIconMigration';
var $e760f08ed9817a42$var$_default = module.exports.default = $e760f08ed9817a42$var$SettingsIcon;

});

parcelRegister("9Mqt3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14f0cd2a1a9557d41447884bb8767d59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71ed20b11366d2ff$var$_react = $71ed20b11366d2ff$var$_interopRequireDefault((parcelRequire("42omo")));

var $71ed20b11366d2ff$var$_checkboxChecked = $71ed20b11366d2ff$var$_interopRequireDefault((parcelRequire("7FcUt")));

var $71ed20b11366d2ff$var$_task = $71ed20b11366d2ff$var$_interopRequireDefault((parcelRequire("j0spP")));
function $71ed20b11366d2ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckboxCheckedIcon.
 * This component is CheckboxCheckedIcon, with `UNSAFE_fallbackIcon` set to "EditorTaskIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71ed20b11366d2ff$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $71ed20b11366d2ff$var$_react.default.createElement($71ed20b11366d2ff$var$_checkboxChecked.default, Object.assign({
        name: "CheckboxCheckedIcon",
        LEGACY_fallbackIcon: $71ed20b11366d2ff$var$_task.default
    }, props));
$71ed20b11366d2ff$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIconMigration';
var $71ed20b11366d2ff$var$_default = module.exports.default = $71ed20b11366d2ff$var$CheckboxCheckedIcon;

});

parcelRegister("7FcUt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3cffb1e2896c4c9b0f7d38ebabc4260>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5946605c631f6a0e$var$_react = $5946605c631f6a0e$var$_interopRequireDefault((parcelRequire("42omo")));

var $5946605c631f6a0e$var$_baseNew = $5946605c631f6a0e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5946605c631f6a0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5946605c631f6a0e$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $5946605c631f6a0e$var$_react.default.createElement($5946605c631f6a0e$var$_baseNew.default, Object.assign({
        name: "CheckboxCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$5946605c631f6a0e$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $5946605c631f6a0e$var$_default = module.exports.default = $5946605c631f6a0e$var$CheckboxCheckedIcon;

});

parcelRegister("bEj0i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::389823b40aad588b43ecd72e237cdac0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b22be10614aae2$var$_react = $87b22be10614aae2$var$_interopRequireDefault((parcelRequire("42omo")));

var $87b22be10614aae2$var$_linkBroken = $87b22be10614aae2$var$_interopRequireDefault((parcelRequire("dZMVn")));

var $87b22be10614aae2$var$_unlink = $87b22be10614aae2$var$_interopRequireDefault((parcelRequire("bnpWc")));
function $87b22be10614aae2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkBrokenIcon.
 * This component is LinkBrokenIcon, with `UNSAFE_fallbackIcon` set to "EditorUnlinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87b22be10614aae2$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $87b22be10614aae2$var$_react.default.createElement($87b22be10614aae2$var$_linkBroken.default, Object.assign({
        name: "LinkBrokenIcon",
        LEGACY_fallbackIcon: $87b22be10614aae2$var$_unlink.default
    }, props));
$87b22be10614aae2$var$LinkBrokenIcon.displayName = 'LinkBrokenIconMigration';
var $87b22be10614aae2$var$_default = module.exports.default = $87b22be10614aae2$var$LinkBrokenIcon;

});

parcelRegister("kCWfQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::010e4a044c21a644c0b907c418c4e39c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0448b6391a79a32$var$_react = $f0448b6391a79a32$var$_interopRequireDefault((parcelRequire("42omo")));

var $f0448b6391a79a32$var$_statusWarning = $f0448b6391a79a32$var$_interopRequireDefault((parcelRequire("ebrpi")));

var $f0448b6391a79a32$var$_warning = $f0448b6391a79a32$var$_interopRequireDefault((parcelRequire("5MbuW")));
function $f0448b6391a79a32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0448b6391a79a32$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $f0448b6391a79a32$var$_react.default.createElement($f0448b6391a79a32$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $f0448b6391a79a32$var$_warning.default
    }, props));
$f0448b6391a79a32$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $f0448b6391a79a32$var$_default = module.exports.default = $f0448b6391a79a32$var$StatusWarningIcon;

});

parcelRegister("ebrpi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5375a398d03dbd3$var$_react = $a5375a398d03dbd3$var$_interopRequireDefault((parcelRequire("42omo")));

var $a5375a398d03dbd3$var$_baseNew = $a5375a398d03dbd3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a5375a398d03dbd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5375a398d03dbd3$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $a5375a398d03dbd3$var$_react.default.createElement($a5375a398d03dbd3$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$a5375a398d03dbd3$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $a5375a398d03dbd3$var$_default = module.exports.default = $a5375a398d03dbd3$var$StatusWarningIcon;

});

parcelRegister("bgJk4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2af12b1489cad8386543f983c1a67716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8344587e14858adf$var$_react = $8344587e14858adf$var$_interopRequireDefault((parcelRequire("42omo")));

var $8344587e14858adf$var$_growDiagonal = $8344587e14858adf$var$_interopRequireDefault((parcelRequire("lOzEN")));

var $8344587e14858adf$var$_actualSize = $8344587e14858adf$var$_interopRequireDefault((parcelRequire("bJViO")));
function $8344587e14858adf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8344587e14858adf$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $8344587e14858adf$var$_react.default.createElement($8344587e14858adf$var$_growDiagonal.default, Object.assign({
        name: "GrowDiagonalIcon",
        LEGACY_fallbackIcon: $8344587e14858adf$var$_actualSize.default
    }, props));
$8344587e14858adf$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIconMigration';
var $8344587e14858adf$var$_default = module.exports.default = $8344587e14858adf$var$GrowDiagonalIcon;

});

parcelRegister("lOzEN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98db7ecf7a88004ad911d912e316fd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe19ed37e94ed81a$var$_react = $fe19ed37e94ed81a$var$_interopRequireDefault((parcelRequire("42omo")));

var $fe19ed37e94ed81a$var$_baseNew = $fe19ed37e94ed81a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fe19ed37e94ed81a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe19ed37e94ed81a$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $fe19ed37e94ed81a$var$_react.default.createElement($fe19ed37e94ed81a$var$_baseNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$fe19ed37e94ed81a$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $fe19ed37e94ed81a$var$_default = module.exports.default = $fe19ed37e94ed81a$var$GrowDiagonalIcon;

});

parcelRegister("8JHjV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52a17cfb35b19ee3ae1ff9abc93d8023>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65c4213c7d0c1a34$var$_react = $65c4213c7d0c1a34$var$_interopRequireDefault((parcelRequire("42omo")));

var $65c4213c7d0c1a34$var$_showMoreHorizontal = $65c4213c7d0c1a34$var$_interopRequireDefault((parcelRequire("9VJDA")));

var $65c4213c7d0c1a34$var$_more = $65c4213c7d0c1a34$var$_interopRequireDefault((parcelRequire("8j0Ak")));
function $65c4213c7d0c1a34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65c4213c7d0c1a34$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $65c4213c7d0c1a34$var$_react.default.createElement($65c4213c7d0c1a34$var$_showMoreHorizontal.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        LEGACY_fallbackIcon: $65c4213c7d0c1a34$var$_more.default
    }, props));
$65c4213c7d0c1a34$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIconMigration';
var $65c4213c7d0c1a34$var$_default = module.exports.default = $65c4213c7d0c1a34$var$ShowMoreHorizontalIcon;

});

parcelRegister("5CLlM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1cf75b90a238d5d18d902ac995f2545e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41853b21da157626$var$_react = $41853b21da157626$var$_interopRequireDefault((parcelRequire("42omo")));

var $41853b21da157626$var$_customize = $41853b21da157626$var$_interopRequireDefault((parcelRequire("isYda")));

var $41853b21da157626$var$_preferences = $41853b21da157626$var$_interopRequireDefault((parcelRequire("jPIdX")));
function $41853b21da157626$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41853b21da157626$var$CustomizeIcon = (props)=>/*#__PURE__*/ $41853b21da157626$var$_react.default.createElement($41853b21da157626$var$_customize.default, Object.assign({
        name: "CustomizeIcon",
        LEGACY_fallbackIcon: $41853b21da157626$var$_preferences.default
    }, props));
$41853b21da157626$var$CustomizeIcon.displayName = 'CustomizeIconMigration';
var $41853b21da157626$var$_default = module.exports.default = $41853b21da157626$var$CustomizeIcon;

});

parcelRegister("gqQg4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c64b1bb7f30549dd379d26abd8d4a76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf679c735bc86c51$var$_react = $bf679c735bc86c51$var$_interopRequireDefault((parcelRequire("42omo")));

var $bf679c735bc86c51$var$_crossCircle = $bf679c735bc86c51$var$_interopRequireDefault((parcelRequire("7yDmn")));

var $bf679c735bc86c51$var$_selectClear = $bf679c735bc86c51$var$_interopRequireDefault((parcelRequire("cPXGO")));
function $bf679c735bc86c51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf679c735bc86c51$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $bf679c735bc86c51$var$_react.default.createElement($bf679c735bc86c51$var$_crossCircle.default, Object.assign({
        name: "CrossCircleIcon",
        LEGACY_fallbackIcon: $bf679c735bc86c51$var$_selectClear.default
    }, props));
$bf679c735bc86c51$var$CrossCircleIcon.displayName = 'CrossCircleIconMigration';
var $bf679c735bc86c51$var$_default = module.exports.default = $bf679c735bc86c51$var$CrossCircleIcon;

});

parcelRegister("3bV1Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5b21f6ad1e09e24ff998a38c2834ac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $252ea2e5ece4f8a8$var$_react = $252ea2e5ece4f8a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $252ea2e5ece4f8a8$var$_arrowLeft = $252ea2e5ece4f8a8$var$_interopRequireDefault((parcelRequire("bPdpL")));

var $252ea2e5ece4f8a8$var$_arrowLeft2 = $252ea2e5ece4f8a8$var$_interopRequireDefault((parcelRequire("fJmzg")));
function $252ea2e5ece4f8a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $252ea2e5ece4f8a8$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $252ea2e5ece4f8a8$var$_react.default.createElement($252ea2e5ece4f8a8$var$_arrowLeft.default, Object.assign({
        name: "ArrowLeftIcon",
        LEGACY_fallbackIcon: $252ea2e5ece4f8a8$var$_arrowLeft2.default
    }, props));
$252ea2e5ece4f8a8$var$ArrowLeftIcon.displayName = 'ArrowLeftIconMigration';
var $252ea2e5ece4f8a8$var$_default = module.exports.default = $252ea2e5ece4f8a8$var$ArrowLeftIcon;

});

parcelRegister("bPdpL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2156d9d42c2a1cee4be11481dce76dec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89bedcfc875a52d0$var$_react = $89bedcfc875a52d0$var$_interopRequireDefault((parcelRequire("42omo")));

var $89bedcfc875a52d0$var$_baseNew = $89bedcfc875a52d0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $89bedcfc875a52d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89bedcfc875a52d0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $89bedcfc875a52d0$var$_react.default.createElement($89bedcfc875a52d0$var$_baseNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$89bedcfc875a52d0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $89bedcfc875a52d0$var$_default = module.exports.default = $89bedcfc875a52d0$var$ArrowLeftIcon;

});

parcelRegister("4HvFx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01fe897a0e06a68c5bba306cb49fbc94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36c3be65d84e334b$var$_react = $36c3be65d84e334b$var$_interopRequireDefault((parcelRequire("42omo")));

var $36c3be65d84e334b$var$_arrowRight = $36c3be65d84e334b$var$_interopRequireDefault((parcelRequire("5tOl1")));

var $36c3be65d84e334b$var$_arrowRight2 = $36c3be65d84e334b$var$_interopRequireDefault((parcelRequire("eEQFA")));
function $36c3be65d84e334b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36c3be65d84e334b$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $36c3be65d84e334b$var$_react.default.createElement($36c3be65d84e334b$var$_arrowRight.default, Object.assign({
        name: "ArrowRightIcon",
        LEGACY_fallbackIcon: $36c3be65d84e334b$var$_arrowRight2.default
    }, props));
$36c3be65d84e334b$var$ArrowRightIcon.displayName = 'ArrowRightIconMigration';
var $36c3be65d84e334b$var$_default = module.exports.default = $36c3be65d84e334b$var$ArrowRightIcon;

});

parcelRegister("5tOl1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01079791ac69b5c9$var$_react = $01079791ac69b5c9$var$_interopRequireDefault((parcelRequire("42omo")));

var $01079791ac69b5c9$var$_baseNew = $01079791ac69b5c9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $01079791ac69b5c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $01079791ac69b5c9$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $01079791ac69b5c9$var$_react.default.createElement($01079791ac69b5c9$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$01079791ac69b5c9$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $01079791ac69b5c9$var$_default = module.exports.default = $01079791ac69b5c9$var$ArrowRightIcon;

});

parcelRegister("7kzZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5566504761f2a610$var$_react = $5566504761f2a610$var$_interopRequireDefault((parcelRequire("42omo")));

var $5566504761f2a610$var$_chevronDown = $5566504761f2a610$var$_interopRequireDefault((parcelRequire("ghftu")));

var $5566504761f2a610$var$_chevronDown2 = $5566504761f2a610$var$_interopRequireDefault((parcelRequire("klvaQ")));
function $5566504761f2a610$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5566504761f2a610$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5566504761f2a610$var$_react.default.createElement($5566504761f2a610$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $5566504761f2a610$var$_chevronDown2.default
    }, props));
$5566504761f2a610$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $5566504761f2a610$var$_default = module.exports.default = $5566504761f2a610$var$ChevronDownIcon;

});

parcelRegister("bRp3h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9cb74f2028aa6054041d7e3a8cf2e8e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $023a73ee490a0c8b$var$_react = $023a73ee490a0c8b$var$_interopRequireDefault((parcelRequire("42omo")));

var $023a73ee490a0c8b$var$_crossCircle = $023a73ee490a0c8b$var$_interopRequireDefault((parcelRequire("7yDmn")));

var $023a73ee490a0c8b$var$_crossCircle2 = $023a73ee490a0c8b$var$_interopRequireDefault((parcelRequire("jJfRl")));
function $023a73ee490a0c8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $023a73ee490a0c8b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $023a73ee490a0c8b$var$_react.default.createElement($023a73ee490a0c8b$var$_crossCircle.default, Object.assign({
        name: "CrossCircleIcon",
        LEGACY_fallbackIcon: $023a73ee490a0c8b$var$_crossCircle2.default
    }, props));
$023a73ee490a0c8b$var$CrossCircleIcon.displayName = 'CrossCircleIconMigration';
var $023a73ee490a0c8b$var$_default = module.exports.default = $023a73ee490a0c8b$var$CrossCircleIcon;

});

parcelRegister("jNfTW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e68eed95d6d66da2$var$_react = $e68eed95d6d66da2$var$_interopRequireDefault((parcelRequire("42omo")));

var $e68eed95d6d66da2$var$_cross = $e68eed95d6d66da2$var$_interopRequireDefault((parcelRequire("hmuev")));

var $e68eed95d6d66da2$var$_cross2 = $e68eed95d6d66da2$var$_interopRequireDefault((parcelRequire("ge0Ua")));
function $e68eed95d6d66da2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e68eed95d6d66da2$var$CrossIcon = (props)=>/*#__PURE__*/ $e68eed95d6d66da2$var$_react.default.createElement($e68eed95d6d66da2$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $e68eed95d6d66da2$var$_cross2.default
    }, props));
$e68eed95d6d66da2$var$CrossIcon.displayName = 'CrossIconMigration';
var $e68eed95d6d66da2$var$_default = module.exports.default = $e68eed95d6d66da2$var$CrossIcon;

});

parcelRegister("hmuev", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca3bf15ae8c7c28f$var$_react = $ca3bf15ae8c7c28f$var$_interopRequireDefault((parcelRequire("42omo")));

var $ca3bf15ae8c7c28f$var$_baseNew = $ca3bf15ae8c7c28f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ca3bf15ae8c7c28f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca3bf15ae8c7c28f$var$CrossIcon = (props)=>/*#__PURE__*/ $ca3bf15ae8c7c28f$var$_react.default.createElement($ca3bf15ae8c7c28f$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$ca3bf15ae8c7c28f$var$CrossIcon.displayName = 'CrossIcon';
var $ca3bf15ae8c7c28f$var$_default = module.exports.default = $ca3bf15ae8c7c28f$var$CrossIcon;

});

parcelRegister("5GDNB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5776dc85eb34bd4bbf9313d62b1b5459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $423fbf47e319c5fe$var$_react = $423fbf47e319c5fe$var$_interopRequireDefault((parcelRequire("42omo")));

var $423fbf47e319c5fe$var$_email = $423fbf47e319c5fe$var$_interopRequireDefault((parcelRequire("ldfch")));

var $423fbf47e319c5fe$var$_email2 = $423fbf47e319c5fe$var$_interopRequireDefault((parcelRequire("jc9Cb")));
function $423fbf47e319c5fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $423fbf47e319c5fe$var$EmailIcon = (props)=>/*#__PURE__*/ $423fbf47e319c5fe$var$_react.default.createElement($423fbf47e319c5fe$var$_email.default, Object.assign({
        name: "EmailIcon",
        LEGACY_fallbackIcon: $423fbf47e319c5fe$var$_email2.default
    }, props));
$423fbf47e319c5fe$var$EmailIcon.displayName = 'EmailIconMigration';
var $423fbf47e319c5fe$var$_default = module.exports.default = $423fbf47e319c5fe$var$EmailIcon;

});

parcelRegister("9coBC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7923b0b29c3f4de7c1e66a726f03f5d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b28523c265710c1$var$_react = $6b28523c265710c1$var$_interopRequireDefault((parcelRequire("42omo")));

var $6b28523c265710c1$var$_feedback = $6b28523c265710c1$var$_interopRequireDefault((parcelRequire("7yOcR")));

var $6b28523c265710c1$var$_feedback2 = $6b28523c265710c1$var$_interopRequireDefault((parcelRequire("45NuA")));
function $6b28523c265710c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b28523c265710c1$var$FeedbackIcon = (props)=>/*#__PURE__*/ $6b28523c265710c1$var$_react.default.createElement($6b28523c265710c1$var$_feedback.default, Object.assign({
        name: "FeedbackIcon",
        LEGACY_fallbackIcon: $6b28523c265710c1$var$_feedback2.default
    }, props));
$6b28523c265710c1$var$FeedbackIcon.displayName = 'FeedbackIconMigration';
var $6b28523c265710c1$var$_default = module.exports.default = $6b28523c265710c1$var$FeedbackIcon;

});

parcelRegister("1dusJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6cb88e2f2689b833163eb837a986d615>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e2ea287089b1269$var$_react = $0e2ea287089b1269$var$_interopRequireDefault((parcelRequire("42omo")));

var $0e2ea287089b1269$var$_baseNew = $0e2ea287089b1269$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0e2ea287089b1269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e2ea287089b1269$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $0e2ea287089b1269$var$_react.default.createElement($0e2ea287089b1269$var$_baseNew.default, Object.assign({
        name: "AlignImageLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$0e2ea287089b1269$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $0e2ea287089b1269$var$_default = module.exports.default = $0e2ea287089b1269$var$AlignImageLeftIcon;

});

parcelRegister("9Y9Mx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7bbc09938ed9e286f5042595c4dccad5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74214e1ec9117b99$var$_react = $74214e1ec9117b99$var$_interopRequireDefault((parcelRequire("42omo")));

var $74214e1ec9117b99$var$_baseNew = $74214e1ec9117b99$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $74214e1ec9117b99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74214e1ec9117b99$var$AlignImageRightIcon = (props)=>/*#__PURE__*/ $74214e1ec9117b99$var$_react.default.createElement($74214e1ec9117b99$var$_baseNew.default, Object.assign({
        name: "AlignImageRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$74214e1ec9117b99$var$AlignImageRightIcon.displayName = 'AlignImageRightIcon';
var $74214e1ec9117b99$var$_default = module.exports.default = $74214e1ec9117b99$var$AlignImageRightIcon;

});

parcelRegister("fxBfz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee248cff197501222c434364c4f923a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b506d533fe8a0cdf$var$_react = $b506d533fe8a0cdf$var$_interopRequireDefault((parcelRequire("42omo")));

var $b506d533fe8a0cdf$var$_baseNew = $b506d533fe8a0cdf$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b506d533fe8a0cdf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b506d533fe8a0cdf$var$AutomationIcon = (props)=>/*#__PURE__*/ $b506d533fe8a0cdf$var$_react.default.createElement($b506d533fe8a0cdf$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$b506d533fe8a0cdf$var$AutomationIcon.displayName = 'AutomationIcon';
var $b506d533fe8a0cdf$var$_default = module.exports.default = $b506d533fe8a0cdf$var$AutomationIcon;

});

parcelRegister("4BqOc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c248cb8ff46f92a14313d2de4318df80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $359f69ca2b6289ab$var$_react = $359f69ca2b6289ab$var$_interopRequireDefault((parcelRequire("42omo")));

var $359f69ca2b6289ab$var$_baseNew = $359f69ca2b6289ab$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $359f69ca2b6289ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $359f69ca2b6289ab$var$ChangesIcon = (props)=>/*#__PURE__*/ $359f69ca2b6289ab$var$_react.default.createElement($359f69ca2b6289ab$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$359f69ca2b6289ab$var$ChangesIcon.displayName = 'ChangesIcon';
var $359f69ca2b6289ab$var$_default = module.exports.default = $359f69ca2b6289ab$var$ChangesIcon;

});

parcelRegister("cvXh8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91c65c25a9968649$var$_react = $91c65c25a9968649$var$_interopRequireDefault((parcelRequire("42omo")));

var $91c65c25a9968649$var$_baseNew = $91c65c25a9968649$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $91c65c25a9968649$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $91c65c25a9968649$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $91c65c25a9968649$var$_react.default.createElement($91c65c25a9968649$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$91c65c25a9968649$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $91c65c25a9968649$var$_default = module.exports.default = $91c65c25a9968649$var$CheckMarkIcon;

});

parcelRegister("iSulU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4e628ea814f393cf264d604c04f2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbe4d081f45335f6$var$_react = $dbe4d081f45335f6$var$_interopRequireDefault((parcelRequire("42omo")));

var $dbe4d081f45335f6$var$_baseNew = $dbe4d081f45335f6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dbe4d081f45335f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbe4d081f45335f6$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $dbe4d081f45335f6$var$_react.default.createElement($dbe4d081f45335f6$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$dbe4d081f45335f6$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $dbe4d081f45335f6$var$_default = module.exports.default = $dbe4d081f45335f6$var$ChevronDoubleRightIcon;

});

parcelRegister("fNJG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80edd69ce46ac6c$var$_react = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("42omo")));

var $b80edd69ce46ac6c$var$_baseNew = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b80edd69ce46ac6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b80edd69ce46ac6c$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b80edd69ce46ac6c$var$_react.default.createElement($b80edd69ce46ac6c$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b80edd69ce46ac6c$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b80edd69ce46ac6c$var$_default = module.exports.default = $b80edd69ce46ac6c$var$CloudArrowUpIcon;

});

parcelRegister("3uQ0E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::becdeda8f8450c41ab5988200094862a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28bc846ec4643487$var$_react = $28bc846ec4643487$var$_interopRequireDefault((parcelRequire("42omo")));

var $28bc846ec4643487$var$_baseNew = $28bc846ec4643487$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $28bc846ec4643487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthNarrow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a narrow width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28bc846ec4643487$var$ContentWidthNarrowIcon = (props)=>/*#__PURE__*/ $28bc846ec4643487$var$_react.default.createElement($28bc846ec4643487$var$_baseNew.default, Object.assign({
        name: "ContentWidthNarrowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5H2V1h12zm-10.5 3v5h9v-5zM3.375 4h9.25C13.385 4 14 4.616 14 5.375v5.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 12 2 11.384 2 10.625v-5.25C2 4.615 2.616 4 3.375 4M14 15H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$28bc846ec4643487$var$ContentWidthNarrowIcon.displayName = 'ContentWidthNarrowIcon';
var $28bc846ec4643487$var$_default = module.exports.default = $28bc846ec4643487$var$ContentWidthNarrowIcon;

});

parcelRegister("9Ctkw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2494db76a67b997170fcc19554c20c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $700e69f9abed7b88$var$_react = $700e69f9abed7b88$var$_interopRequireDefault((parcelRequire("42omo")));

var $700e69f9abed7b88$var$_baseNew = $700e69f9abed7b88$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $700e69f9abed7b88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $700e69f9abed7b88$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $700e69f9abed7b88$var$_react.default.createElement($700e69f9abed7b88$var$_baseNew.default, Object.assign({
        name: "ContentWrapLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$700e69f9abed7b88$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $700e69f9abed7b88$var$_default = module.exports.default = $700e69f9abed7b88$var$ContentWrapLeftIcon;

});

parcelRegister("4jUBz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3254d85c74ed008f$var$_react = $3254d85c74ed008f$var$_interopRequireDefault((parcelRequire("42omo")));

var $3254d85c74ed008f$var$_baseNew = $3254d85c74ed008f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3254d85c74ed008f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3254d85c74ed008f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $3254d85c74ed008f$var$_react.default.createElement($3254d85c74ed008f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$3254d85c74ed008f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $3254d85c74ed008f$var$_default = module.exports.default = $3254d85c74ed008f$var$DiscoveryIcon;

});

parcelRegister("j398X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c3d7920d21840bbdbda77777279aae7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dde563d5581cd693$var$_react = $dde563d5581cd693$var$_interopRequireDefault((parcelRequire("42omo")));

var $dde563d5581cd693$var$_baseNew = $dde563d5581cd693$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dde563d5581cd693$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiCasual".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a casual or relaxed tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dde563d5581cd693$var$EmojiCasualIcon = (props)=>/*#__PURE__*/ $dde563d5581cd693$var$_react.default.createElement($dde563d5581cd693$var$_baseNew.default, Object.assign({
        name: "EmojiCasualIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.776 6.119.279 1.3A2 2 0 0 0 4.01 9h1.054a2.625 2.625 0 0 0 2.61-2.345L7.8 5.5h.4l.124 1.155A2.625 2.625 0 0 0 10.935 9h1.054a2 2 0 0 0 1.956-1.58l.279-1.301a6.5 6.5 0 1 1-12.448 0M13.124 4A6.49 6.49 0 0 0 8 1.5c-2.08 0-3.934.977-5.124 2.5zm-.302 1.5H9.71l.106.995A1.125 1.125 0 0 0 10.935 7.5h1.054a.5.5 0 0 0 .49-.395zm-6.532 0H3.178l.344 1.605a.5.5 0 0 0 .489.395h1.054c.575 0 1.058-.433 1.119-1.005zM.847 4.413A8 8 0 0 1 8 0a8 8 0 1 1 0 16A8 8 0 0 1 .847 4.413m5.238 6.12c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .69-.675l.031-.04.005-.006-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513m4.556-.721" clip-rule="evenodd"/>`
    }, props));
$dde563d5581cd693$var$EmojiCasualIcon.displayName = 'EmojiCasualIcon';
var $dde563d5581cd693$var$_default = module.exports.default = $dde563d5581cd693$var$EmojiCasualIcon;

});

parcelRegister("kMl1Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2ac947f63209d241272a5f59270c101>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2089aa57b5b8b7d$var$_react = $f2089aa57b5b8b7d$var$_interopRequireDefault((parcelRequire("42omo")));

var $f2089aa57b5b8b7d$var$_baseNew = $f2089aa57b5b8b7d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f2089aa57b5b8b7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiNeutral".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a neutral tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2089aa57b5b8b7d$var$EmojiNeutralIcon = (props)=>/*#__PURE__*/ $f2089aa57b5b8b7d$var$_react.default.createElement($f2089aa57b5b8b7d$var$_baseNew.default, Object.assign({
        name: "EmojiNeutralIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m2.25 3.25V11h-6.5V9.5z" clip-rule="evenodd"/>`
    }, props));
$f2089aa57b5b8b7d$var$EmojiNeutralIcon.displayName = 'EmojiNeutralIcon';
var $f2089aa57b5b8b7d$var$_default = module.exports.default = $f2089aa57b5b8b7d$var$EmojiNeutralIcon;

});

parcelRegister("2G5zx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3fcc7ec4e4a90ef6f278af13d73450d0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f33d38551414dee$var$_react = $1f33d38551414dee$var$_interopRequireDefault((parcelRequire("42omo")));

var $1f33d38551414dee$var$_baseNew = $1f33d38551414dee$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1f33d38551414dee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for removing emoji.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f33d38551414dee$var$EmojiRemoveIcon = (props)=>/*#__PURE__*/ $1f33d38551414dee$var$_react.default.createElement($1f33d38551414dee$var$_baseNew.default, Object.assign({
        name: "EmojiRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.72 13.9 1.12 1.12A8 8 0 0 1 .98 4.16L2.1 5.28a6.5 6.5 0 0 0 8.63 8.63M8 0C6.61 0 5.3.36 4.16.98L5.28 2.1a6.5 6.5 0 0 1 8.63 8.63l1.12 1.12A8 8 0 0 0 8 0"/><path fill="currentcolor" d="m9.06 5.88 1.57 1.57a1.25 1.25 0 1 0-1.57-1.57m-2.97 4.15c.38.3.87.57 1.44.67l1.43 1.43c-.3.07-.62.11-.96.11-1.23 0-2.2-.54-2.83-1.03a6 6 0 0 1-.94-.92l-.06-.07-.02-.02-.01-.01.61-.44.61-.44.01.01.03.04q.05.06.14.16c.13.14.31.33.55.51M.47 1.53l14 14 1.06-1.06-14-14z"/>`
    }, props));
$1f33d38551414dee$var$EmojiRemoveIcon.displayName = 'EmojiRemoveIcon';
var $1f33d38551414dee$var$_default = module.exports.default = $1f33d38551414dee$var$EmojiRemoveIcon;

});

parcelRegister("4SWbm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38e956594bc2295e$var$_react = $38e956594bc2295e$var$_interopRequireDefault((parcelRequire("42omo")));

var $38e956594bc2295e$var$_baseNew = $38e956594bc2295e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $38e956594bc2295e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38e956594bc2295e$var$EpicIcon = (props)=>/*#__PURE__*/ $38e956594bc2295e$var$_react.default.createElement($38e956594bc2295e$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$38e956594bc2295e$var$EpicIcon.displayName = 'EpicIcon';
var $38e956594bc2295e$var$_default = module.exports.default = $38e956594bc2295e$var$EpicIcon;

});

parcelRegister("8cjip", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f7e698125b9a7f8$var$_react = $5f7e698125b9a7f8$var$_interopRequireDefault((parcelRequire("42omo")));

var $5f7e698125b9a7f8$var$_baseNew = $5f7e698125b9a7f8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5f7e698125b9a7f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f7e698125b9a7f8$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $5f7e698125b9a7f8$var$_react.default.createElement($5f7e698125b9a7f8$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$5f7e698125b9a7f8$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $5f7e698125b9a7f8$var$_default = module.exports.default = $5f7e698125b9a7f8$var$EyeOpenIcon;

});

parcelRegister("gWb8i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe74ef9c654d922d3ff18f7784d24df9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c54ab2dc9b4306d4$var$_react = $c54ab2dc9b4306d4$var$_interopRequireDefault((parcelRequire("42omo")));

var $c54ab2dc9b4306d4$var$_baseNew = $c54ab2dc9b4306d4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c54ab2dc9b4306d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Glasses".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Changing tone of written content to Educational with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c54ab2dc9b4306d4$var$GlassesIcon = (props)=>/*#__PURE__*/ $c54ab2dc9b4306d4$var$_react.default.createElement($c54ab2dc9b4306d4$var$_baseNew.default, Object.assign({
        name: "GlassesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.81 2.433-1.804.82c-.353.16-.599.491-.65.876l-.433 3.245A3.5 3.5 0 0 1 3.5 7c1.184 0 2.23.587 2.863 1.486A3 3 0 0 1 8 8c.604 0 1.167.179 1.637.486A3.5 3.5 0 0 1 12.5 7c.567 0 1.103.135 1.577.374l-.433-3.245a1.13 1.13 0 0 0-.65-.876l-1.804-.82.62-1.366 1.805.82A2.63 2.63 0 0 1 15.13 3.93l.76 5.697A3.505 3.505 0 0 1 12.5 14a3.5 3.5 0 0 1-3.453-4.074A1.5 1.5 0 0 0 8 9.5c-.407 0-.776.162-1.047.426q.046.281.047.574a3.5 3.5 0 1 1-6.89-.873L.87 3.93a2.63 2.63 0 0 1 1.515-2.042l1.805-.82zM1.5 10.546a2 2 0 1 0 .083-.617zm12.917-.617.082.617a2 2 0 1 1-.082-.617" clip-rule="evenodd"/>`
    }, props));
$c54ab2dc9b4306d4$var$GlassesIcon.displayName = 'GlassesIcon';
var $c54ab2dc9b4306d4$var$_default = module.exports.default = $c54ab2dc9b4306d4$var$GlassesIcon;

});

parcelRegister("1kVeP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2b6456aaf4426c97739f87704196a6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f940f03e44f9ec9$var$_react = $0f940f03e44f9ec9$var$_interopRequireDefault((parcelRequire("42omo")));

var $0f940f03e44f9ec9$var$_baseNew = $0f940f03e44f9ec9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0f940f03e44f9ec9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f940f03e44f9ec9$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $0f940f03e44f9ec9$var$_react.default.createElement($0f940f03e44f9ec9$var$_baseNew.default, Object.assign({
        name: "GrowHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0f940f03e44f9ec9$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $0f940f03e44f9ec9$var$_default = module.exports.default = $0f940f03e44f9ec9$var$GrowHorizontalIcon;

});

parcelRegister("74Ajl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0180dbb14c91e16176b90c5ab90f56c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $526512b5af86da90$var$_react = $526512b5af86da90$var$_interopRequireDefault((parcelRequire("42omo")));

var $526512b5af86da90$var$_baseNew = $526512b5af86da90$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $526512b5af86da90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Highlight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for highlight text tool in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $526512b5af86da90$var$HighlightIcon = (props)=>/*#__PURE__*/ $526512b5af86da90$var$_react.default.createElement($526512b5af86da90$var$_baseNew.default, Object.assign({
        name: "HighlightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.516.31a1.375 1.375 0 0 1 1.76.155l1.259 1.26c.471.47.537 1.212.155 1.759L9.365 9.679a.75.75 0 0 1-.363.277l-3.5 1.25a.75.75 0 0 1-.782-.176l-.095-.094-.595.594a.75.75 0 0 1-1.06 0l-.5-.5a.75.75 0 0 1 0-1.06l.594-.595-.094-.095a.75.75 0 0 1-.176-.782l1.25-3.5a.75.75 0 0 1 .277-.363zm.773 1.29L5.913 5.353l2.734 2.734L12.4 2.71zM7.382 8.942 5.058 6.618l-.692 1.937 1.079 1.08z" clip-rule="evenodd"/>`
    }, props));
$526512b5af86da90$var$HighlightIcon.displayName = 'HighlightIcon';
var $526512b5af86da90$var$_default = module.exports.default = $526512b5af86da90$var$HighlightIcon;

});

parcelRegister("2tC8Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9192cbdac48cc13a6ba11749984434b1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1cdbe0d39b1aea2b$var$_react = $1cdbe0d39b1aea2b$var$_interopRequireDefault((parcelRequire("42omo")));

var $1cdbe0d39b1aea2b$var$_baseNew = $1cdbe0d39b1aea2b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1cdbe0d39b1aea2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageInline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing inline images in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1cdbe0d39b1aea2b$var$ImageInlineIcon = (props)=>/*#__PURE__*/ $1cdbe0d39b1aea2b$var$_react.default.createElement($1cdbe0d39b1aea2b$var$_baseNew.default, Object.assign({
        name: "ImageInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6.375C0 5.615.616 5 1.375 5h3.25C5.385 5 6 5.616 6 6.375v3.25C6 10.385 5.384 11 4.625 11h-3.25C.615 11 0 10.384 0 9.625zm1.5.125v3h3v-3zM16 8.75H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$1cdbe0d39b1aea2b$var$ImageInlineIcon.displayName = 'ImageInlineIcon';
var $1cdbe0d39b1aea2b$var$_default = module.exports.default = $1cdbe0d39b1aea2b$var$ImageInlineIcon;

});

parcelRegister("f22ZH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cc30cca446ee2bc7bd4f679561c5adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af195d81409eacaa$var$_react = $af195d81409eacaa$var$_interopRequireDefault((parcelRequire("42omo")));

var $af195d81409eacaa$var$_baseNew = $af195d81409eacaa$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $af195d81409eacaa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af195d81409eacaa$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $af195d81409eacaa$var$_react.default.createElement($af195d81409eacaa$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$af195d81409eacaa$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $af195d81409eacaa$var$_default = module.exports.default = $af195d81409eacaa$var$LayoutThreeColumnsIcon;

});

parcelRegister("8tdj3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b603e49d606132e091f78e8fc1c638c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ab5a81461bade1$var$_react = $62ab5a81461bade1$var$_interopRequireDefault((parcelRequire("42omo")));

var $62ab5a81461bade1$var$_baseNew = $62ab5a81461bade1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $62ab5a81461bade1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62ab5a81461bade1$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $62ab5a81461bade1$var$_react.default.createElement($62ab5a81461bade1$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$62ab5a81461bade1$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $62ab5a81461bade1$var$_default = module.exports.default = $62ab5a81461bade1$var$LinkExternalIcon;

});

parcelRegister("h1ewt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63dcb99536cc850$var$_react = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("42omo")));

var $c63dcb99536cc850$var$_baseNew = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c63dcb99536cc850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63dcb99536cc850$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $c63dcb99536cc850$var$_react.default.createElement($c63dcb99536cc850$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c63dcb99536cc850$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $c63dcb99536cc850$var$_default = module.exports.default = $c63dcb99536cc850$var$LockUnlockedIcon;

});

parcelRegister("bAxHS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4e115bf1196067744edbc137a8f667f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86fd33f7b3df1ba6$var$_react = $86fd33f7b3df1ba6$var$_interopRequireDefault((parcelRequire("42omo")));

var $86fd33f7b3df1ba6$var$_baseNew = $86fd33f7b3df1ba6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $86fd33f7b3df1ba6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Microphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: record sounds in Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86fd33f7b3df1ba6$var$MicrophoneIcon = (props)=>/*#__PURE__*/ $86fd33f7b3df1ba6$var$_react.default.createElement($86fd33f7b3df1ba6$var$_baseNew.default, Object.assign({
        name: "MicrophoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A1.5 1.5 0 0 0 6.5 3v4a1.5 1.5 0 1 0 3 0V3A1.5 1.5 0 0 0 8 1.5M5 3a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zM3.5 7a4.5 4.5 0 0 0 9 0H14c0 3.06-2.29 5.585-5.25 5.954V14.5H12V16H4v-1.5h3.25v-1.546A6 6 0 0 1 2 7z" clip-rule="evenodd"/>`
    }, props));
$86fd33f7b3df1ba6$var$MicrophoneIcon.displayName = 'MicrophoneIcon';
var $86fd33f7b3df1ba6$var$_default = module.exports.default = $86fd33f7b3df1ba6$var$MicrophoneIcon;

});

parcelRegister("5Yp2m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efc4ad949a44efb0684f52ead162d030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4595fa2a3e3f9b8e$var$_react = $4595fa2a3e3f9b8e$var$_interopRequireDefault((parcelRequire("42omo")));

var $4595fa2a3e3f9b8e$var$_baseNew = $4595fa2a3e3f9b8e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4595fa2a3e3f9b8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4595fa2a3e3f9b8e$var$MinusIcon = (props)=>/*#__PURE__*/ $4595fa2a3e3f9b8e$var$_react.default.createElement($4595fa2a3e3f9b8e$var$_baseNew.default, Object.assign({
        name: "MinusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$4595fa2a3e3f9b8e$var$MinusIcon.displayName = 'MinusIcon';
var $4595fa2a3e3f9b8e$var$_default = module.exports.default = $4595fa2a3e3f9b8e$var$MinusIcon;

});

parcelRegister("e66a9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c19f5c5b24be77f10752d711b9d3763d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a436680356724d24$var$_react = $a436680356724d24$var$_interopRequireDefault((parcelRequire("42omo")));

var $a436680356724d24$var$_baseNew = $a436680356724d24$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a436680356724d24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Node".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a non-expandable item in a page tree.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a436680356724d24$var$NodeIcon = (props)=>/*#__PURE__*/ $a436680356724d24$var$_react.default.createElement($a436680356724d24$var$_baseNew.default, Object.assign({
        name: "NodeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>`
    }, props));
$a436680356724d24$var$NodeIcon.displayName = 'NodeIcon';
var $a436680356724d24$var$_default = module.exports.default = $a436680356724d24$var$NodeIcon;

});

parcelRegister("4Hqhn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1420a51ed602309945731feddbf94907>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36bf9011bd11cb83$var$_react = $36bf9011bd11cb83$var$_interopRequireDefault((parcelRequire("42omo")));

var $36bf9011bd11cb83$var$_baseNew = $36bf9011bd11cb83$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $36bf9011bd11cb83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Note".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36bf9011bd11cb83$var$NoteIcon = (props)=>/*#__PURE__*/ $36bf9011bd11cb83$var$_react.default.createElement($36bf9011bd11cb83$var$_baseNew.default, Object.assign({
        name: "NoteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 15H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6V9.75A.75.75 0 0 1 9.75 9h3.75V3a.5.5 0 0 0-.5-.5zm9.94 8H10.5v2.44zM11 6H4V4.5h7zM7 9.5H4V8h3z" clip-rule="evenodd"/>`
    }, props));
$36bf9011bd11cb83$var$NoteIcon.displayName = 'NoteIcon';
var $36bf9011bd11cb83$var$_default = module.exports.default = $36bf9011bd11cb83$var$NoteIcon;

});

parcelRegister("4wwVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5a2b32fe863ac429d199dc8b174e3b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34b3b09757562b8e$var$_react = $34b3b09757562b8e$var$_interopRequireDefault((parcelRequire("42omo")));

var $34b3b09757562b8e$var$_baseNew = $34b3b09757562b8e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $34b3b09757562b8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34b3b09757562b8e$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $34b3b09757562b8e$var$_react.default.createElement($34b3b09757562b8e$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$34b3b09757562b8e$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $34b3b09757562b8e$var$_default = module.exports.default = $34b3b09757562b8e$var$PersonAvatarIcon;

});

parcelRegister("6V1ly", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45707d9c52fa683c21ac6061fb8f413e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50991c5e8073eaa1$var$_react = $50991c5e8073eaa1$var$_interopRequireDefault((parcelRequire("42omo")));

var $50991c5e8073eaa1$var$_baseNew = $50991c5e8073eaa1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $50991c5e8073eaa1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pin".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: unpinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50991c5e8073eaa1$var$PinIcon = (props)=>/*#__PURE__*/ $50991c5e8073eaa1$var$_react.default.createElement($50991c5e8073eaa1$var$_baseNew.default, Object.assign({
        name: "PinIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864a.75.75 0 0 0-.106.386V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$50991c5e8073eaa1$var$PinIcon.displayName = 'PinIcon';
var $50991c5e8073eaa1$var$_default = module.exports.default = $50991c5e8073eaa1$var$PinIcon;

});

parcelRegister("7OYaz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b1be05367c6e6be$var$_react = $5b1be05367c6e6be$var$_interopRequireDefault((parcelRequire("42omo")));

var $5b1be05367c6e6be$var$_baseNew = $5b1be05367c6e6be$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5b1be05367c6e6be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b1be05367c6e6be$var$PullRequestIcon = (props)=>/*#__PURE__*/ $5b1be05367c6e6be$var$_react.default.createElement($5b1be05367c6e6be$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$5b1be05367c6e6be$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $5b1be05367c6e6be$var$_default = module.exports.default = $5b1be05367c6e6be$var$PullRequestIcon;

});

parcelRegister("5j8et", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3dd51cde97e5ec7d$var$_react = $3dd51cde97e5ec7d$var$_interopRequireDefault((parcelRequire("42omo")));

var $3dd51cde97e5ec7d$var$_baseNew = $3dd51cde97e5ec7d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3dd51cde97e5ec7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3dd51cde97e5ec7d$var$ReleaseIcon = (props)=>/*#__PURE__*/ $3dd51cde97e5ec7d$var$_react.default.createElement($3dd51cde97e5ec7d$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$3dd51cde97e5ec7d$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $3dd51cde97e5ec7d$var$_default = module.exports.default = $3dd51cde97e5ec7d$var$ReleaseIcon;

});

parcelRegister("duwSm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4d5f161589a38033248db2607dbad0d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d2794231a9e8f40$var$_react = $9d2794231a9e8f40$var$_interopRequireDefault((parcelRequire("42omo")));

var $9d2794231a9e8f40$var$_baseNew = $9d2794231a9e8f40$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9d2794231a9e8f40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLink".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart links.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d2794231a9e8f40$var$SmartLinkIcon = (props)=>/*#__PURE__*/ $9d2794231a9e8f40$var$_react.default.createElement($9d2794231a9e8f40$var$_baseNew.default, Object.assign({
        name: "SmartLinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.117 1.547a3.933 3.933 0 0 1 4.663 6.234l-2.25 2.25-1.06-1.061 2.25-2.25a2.432 2.432 0 0 0-2.604-3.986q.132.361.134.766a2.25 2.25 0 1 1-1.133-1.953M8 2.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 2.604 3.987 2.25 2.25 0 1 1 .998 1.187A3.933 3.933 0 0 1 2.22 8.22M8 11.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$9d2794231a9e8f40$var$SmartLinkIcon.displayName = 'SmartLinkIcon';
var $9d2794231a9e8f40$var$_default = module.exports.default = $9d2794231a9e8f40$var$SmartLinkIcon;

});

parcelRegister("99wB5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b41205595ae662eed4f6fa7d0da6a5f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a9e3d71ec5c1936$var$_react = $6a9e3d71ec5c1936$var$_interopRequireDefault((parcelRequire("42omo")));

var $6a9e3d71ec5c1936$var$_baseNew = $6a9e3d71ec5c1936$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6a9e3d71ec5c1936$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkEmbed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embeds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a9e3d71ec5c1936$var$SmartLinkEmbedIcon = (props)=>/*#__PURE__*/ $6a9e3d71ec5c1936$var$_react.default.createElement($6a9e3d71ec5c1936$var$_baseNew.default, Object.assign({
        name: "SmartLinkEmbedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4h11V3a.5.5 0 0 0-.5-.5zm10.5 6h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zm-8-3H4V4h1.5zm6.5 0H7V4h5z" clip-rule="evenodd"/>`
    }, props));
$6a9e3d71ec5c1936$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
var $6a9e3d71ec5c1936$var$_default = module.exports.default = $6a9e3d71ec5c1936$var$SmartLinkEmbedIcon;

});

parcelRegister("4c0se", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61f2cd3b3ce75546535a34edc6c6a407>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30d8a2a999090609$var$_react = $30d8a2a999090609$var$_interopRequireDefault((parcelRequire("42omo")));

var $30d8a2a999090609$var$_baseNew = $30d8a2a999090609$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $30d8a2a999090609$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30d8a2a999090609$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $30d8a2a999090609$var$_react.default.createElement($30d8a2a999090609$var$_baseNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$30d8a2a999090609$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $30d8a2a999090609$var$_default = module.exports.default = $30d8a2a999090609$var$SortAscendingIcon;

});

parcelRegister("bh5s2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50a6e4dd8b62d7d7bf2cfae0d8c6979>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835582ba87108709$var$_react = $835582ba87108709$var$_interopRequireDefault((parcelRequire("42omo")));

var $835582ba87108709$var$_baseNew = $835582ba87108709$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $835582ba87108709$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835582ba87108709$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $835582ba87108709$var$_react.default.createElement($835582ba87108709$var$_baseNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$835582ba87108709$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $835582ba87108709$var$_default = module.exports.default = $835582ba87108709$var$StatusVerifiedIcon;

});

parcelRegister("kR5QY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2ed4c3c0db31f3a$var$_react = $f2ed4c3c0db31f3a$var$_interopRequireDefault((parcelRequire("42omo")));

var $f2ed4c3c0db31f3a$var$_baseNew = $f2ed4c3c0db31f3a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f2ed4c3c0db31f3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2ed4c3c0db31f3a$var$StoryIcon = (props)=>/*#__PURE__*/ $f2ed4c3c0db31f3a$var$_react.default.createElement($f2ed4c3c0db31f3a$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$f2ed4c3c0db31f3a$var$StoryIcon.displayName = 'StoryIcon';
var $f2ed4c3c0db31f3a$var$_default = module.exports.default = $f2ed4c3c0db31f3a$var$StoryIcon;

});

parcelRegister("4nv4H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10d7615b6292d70e1de86f8e11f4b3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33016a337ebb928a$var$_react = $33016a337ebb928a$var$_interopRequireDefault((parcelRequire("42omo")));

var $33016a337ebb928a$var$_baseNew = $33016a337ebb928a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $33016a337ebb928a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for splitting joined table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33016a337ebb928a$var$TableCellSplitIcon = (props)=>/*#__PURE__*/ $33016a337ebb928a$var$_react.default.createElement($33016a337ebb928a$var$_baseNew.default, Object.assign({
        name: "TableCellSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 3.5H0V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5m6 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zM.22 7.47l2.25-2.25 1.06 1.06L1.81 8l1.72 1.72-1.06 1.06L.22 8.53a.75.75 0 0 1 0-1.06M14.19 8l-1.72-1.72 1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$33016a337ebb928a$var$TableCellSplitIcon.displayName = 'TableCellSplitIcon';
var $33016a337ebb928a$var$_default = module.exports.default = $33016a337ebb928a$var$TableCellSplitIcon;

});

parcelRegister("lvYQd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4462f40c375ebe722466dce1677f33d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa9bb0018e2157d5$var$_react = $fa9bb0018e2157d5$var$_interopRequireDefault((parcelRequire("42omo")));

var $fa9bb0018e2157d5$var$_baseNew = $fa9bb0018e2157d5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fa9bb0018e2157d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table column to the left of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa9bb0018e2157d5$var$TableColumnMoveLeftIcon = (props)=>/*#__PURE__*/ $fa9bb0018e2157d5$var$_react.default.createElement($fa9bb0018e2157d5$var$_baseNew.default, Object.assign({
        name: "TableColumnMoveLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.22 4.47l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72H6v-1.5H2.56l1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$fa9bb0018e2157d5$var$TableColumnMoveLeftIcon.displayName = 'TableColumnMoveLeftIcon';
var $fa9bb0018e2157d5$var$_default = module.exports.default = $fa9bb0018e2157d5$var$TableColumnMoveLeftIcon;

});

parcelRegister("iBNSQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cda528f9679d716d7f767e6ce4137c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8c26089cc549354$var$_react = $d8c26089cc549354$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8c26089cc549354$var$_baseNew = $d8c26089cc549354$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8c26089cc549354$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8c26089cc549354$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $d8c26089cc549354$var$_react.default.createElement($d8c26089cc549354$var$_baseNew.default, Object.assign({
        name: "TableColumnsDistributeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$d8c26089cc549354$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $d8c26089cc549354$var$_default = module.exports.default = $d8c26089cc549354$var$TableColumnsDistributeIcon;

});

parcelRegister("4s9K9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18326ccc0c26c72e4df39b65b2150728>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e155cc01343bee$var$_react = $33e155cc01343bee$var$_interopRequireDefault((parcelRequire("42omo")));

var $33e155cc01343bee$var$_baseNew = $33e155cc01343bee$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $33e155cc01343bee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddBelow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table row below the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e155cc01343bee$var$TableRowAddBelowIcon = (props)=>/*#__PURE__*/ $33e155cc01343bee$var$_react.default.createElement($33e155cc01343bee$var$_baseNew.default, Object.assign({
        name: "TableRowAddBelowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm6.25 7.25H11v1.5H8.75V16h-1.5v-2.25H5v-1.5h2.25V10h1.5z" clip-rule="evenodd"/>`
    }, props));
$33e155cc01343bee$var$TableRowAddBelowIcon.displayName = 'TableRowAddBelowIcon';
var $33e155cc01343bee$var$_default = module.exports.default = $33e155cc01343bee$var$TableRowAddBelowIcon;

});

parcelRegister("HbwpQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a47975d9a6c646363e74cea370b39b9e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $081cf44386c6c160$var$_react = $081cf44386c6c160$var$_interopRequireDefault((parcelRequire("42omo")));

var $081cf44386c6c160$var$_baseNew = $081cf44386c6c160$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $081cf44386c6c160$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for deleting a table row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $081cf44386c6c160$var$TableRowDeleteIcon = (props)=>/*#__PURE__*/ $081cf44386c6c160$var$_react.default.createElement($081cf44386c6c160$var$_baseNew.default, Object.assign({
        name: "TableRowDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm8.5 7.25H5v1.5h6z" clip-rule="evenodd"/>`
    }, props));
$081cf44386c6c160$var$TableRowDeleteIcon.displayName = 'TableRowDeleteIcon';
var $081cf44386c6c160$var$_default = module.exports.default = $081cf44386c6c160$var$TableRowDeleteIcon;

});

parcelRegister("krMwx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e12ad8b9285399e621f8347da1513c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee2bf81396e7c3b9$var$_react = $ee2bf81396e7c3b9$var$_interopRequireDefault((parcelRequire("42omo")));

var $ee2bf81396e7c3b9$var$_baseNew = $ee2bf81396e7c3b9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ee2bf81396e7c3b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveDown".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table row below its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee2bf81396e7c3b9$var$TableRowMoveDownIcon = (props)=>/*#__PURE__*/ $ee2bf81396e7c3b9$var$_react.default.createElement($ee2bf81396e7c3b9$var$_baseNew.default, Object.assign({
        name: "TableRowMoveDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm1.97 7.78 3 3a.75.75 0 0 0 1.06 0l3-3-1.06-1.06-1.72 1.72V10h-1.5v3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$ee2bf81396e7c3b9$var$TableRowMoveDownIcon.displayName = 'TableRowMoveDownIcon';
var $ee2bf81396e7c3b9$var$_default = module.exports.default = $ee2bf81396e7c3b9$var$TableRowMoveDownIcon;

});

parcelRegister("gzmk4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94299558fe30d8b873c5baac0be690ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1013b07f72e2d0e$var$_react = $c1013b07f72e2d0e$var$_interopRequireDefault((parcelRequire("42omo")));

var $c1013b07f72e2d0e$var$_baseNew = $c1013b07f72e2d0e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c1013b07f72e2d0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveUp".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table row above its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1013b07f72e2d0e$var$TableRowMoveUpIcon = (props)=>/*#__PURE__*/ $c1013b07f72e2d0e$var$_react.default.createElement($c1013b07f72e2d0e$var$_baseNew.default, Object.assign({
        name: "TableRowMoveUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm1.97-7.78 3-3a.75.75 0 0 1 1.06 0l3 3-1.06 1.06-1.72-1.72V6h-1.5V2.56L5.53 4.28z" clip-rule="evenodd"/>`
    }, props));
$c1013b07f72e2d0e$var$TableRowMoveUpIcon.displayName = 'TableRowMoveUpIcon';
var $c1013b07f72e2d0e$var$_default = module.exports.default = $c1013b07f72e2d0e$var$TableRowMoveUpIcon;

});

parcelRegister("6DSrS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::967051479008b6df3057b7f835f26a9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d609ef7a1d269d4$var$_react = $4d609ef7a1d269d4$var$_interopRequireDefault((parcelRequire("42omo")));

var $4d609ef7a1d269d4$var$_baseNew = $4d609ef7a1d269d4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4d609ef7a1d269d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d609ef7a1d269d4$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $4d609ef7a1d269d4$var$_react.default.createElement($4d609ef7a1d269d4$var$_baseNew.default, Object.assign({
        name: "TaskToDoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$4d609ef7a1d269d4$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $4d609ef7a1d269d4$var$_default = module.exports.default = $4d609ef7a1d269d4$var$TaskToDoIcon;

});

parcelRegister("f8c3d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e4d05a25c478251d31315596858be41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b040f3715618c2b7$var$_react = $b040f3715618c2b7$var$_interopRequireDefault((parcelRequire("42omo")));

var $b040f3715618c2b7$var$_baseNew = $b040f3715618c2b7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b040f3715618c2b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b040f3715618c2b7$var$TextIcon = (props)=>/*#__PURE__*/ $b040f3715618c2b7$var$_react.default.createElement($b040f3715618c2b7$var$_baseNew.default, Object.assign({
        name: "TextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z" clip-rule="evenodd"/>`
    }, props));
$b040f3715618c2b7$var$TextIcon.displayName = 'TextIcon';
var $b040f3715618c2b7$var$_default = module.exports.default = $b040f3715618c2b7$var$TextIcon;

});

parcelRegister("dRLbl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ea2f9ccde642b201921aa68be6179ead>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a184d2fa6e3dcc79$var$_react = $a184d2fa6e3dcc79$var$_interopRequireDefault((parcelRequire("42omo")));

var $a184d2fa6e3dcc79$var$_baseNew = $a184d2fa6e3dcc79$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a184d2fa6e3dcc79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a184d2fa6e3dcc79$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $a184d2fa6e3dcc79$var$_react.default.createElement($a184d2fa6e3dcc79$var$_baseNew.default, Object.assign({
        name: "TextIndentLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.81 8l2.22-2.22-1.06-1.06-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75 1.06-1.06zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$a184d2fa6e3dcc79$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIcon';
var $a184d2fa6e3dcc79$var$_default = module.exports.default = $a184d2fa6e3dcc79$var$TextIndentLeftIcon;

});

parcelRegister("dLjaJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20df9865399d0da64293437f5db358c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a04e89575dd798d3$var$_react = $a04e89575dd798d3$var$_interopRequireDefault((parcelRequire("42omo")));

var $a04e89575dd798d3$var$_baseNew = $a04e89575dd798d3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a04e89575dd798d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSpellcheck".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spellchecking.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a04e89575dd798d3$var$TextSpellcheckIcon = (props)=>/*#__PURE__*/ $a04e89575dd798d3$var$_react.default.createElement($a04e89575dd798d3$var$_baseNew.default, Object.assign({
        name: "TextSpellcheckIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.67.494A.75.75 0 0 1 5.375 0h.75a.75.75 0 0 1 .705.494l3.625 10a.8.8 0 0 1 .045.256V11H9.06l-.015.006L9.043 11H9v-.118L7.955 8h-4.41L2.5 10.882V11h-.043l-.002.006L2.44 11H1v-.25a.8.8 0 0 1 .045-.256zM4.088 6.5h3.324L5.75 1.916z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m13.928 9.265 1.144.97-4.667 5.5a.75.75 0 0 1-1.144 0l-2.333-2.75 1.144-.97 1.761 2.076z" clip-rule="evenodd"/>`
    }, props));
$a04e89575dd798d3$var$TextSpellcheckIcon.displayName = 'TextSpellcheckIcon';
var $a04e89575dd798d3$var$_default = module.exports.default = $a04e89575dd798d3$var$TextSpellcheckIcon;

});

parcelRegister("jHpAD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4892c276b5463761a4363f071816684>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e575e217847495ac$var$_react = $e575e217847495ac$var$_interopRequireDefault((parcelRequire("42omo")));

var $e575e217847495ac$var$_baseNew = $e575e217847495ac$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e575e217847495ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStrikethrough".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for strikethrough text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e575e217847495ac$var$TextStrikethroughIcon = (props)=>/*#__PURE__*/ $e575e217847495ac$var$_react.default.createElement($e575e217847495ac$var$_baseNew.default, Object.assign({
        name: "TextStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.47 2.5a2.12 2.12 0 0 0-1.79 3.25H4.03a3.59 3.59 0 0 1 .5-3.25A3.62 3.62 0 0 1 7.47 1h.93a4.08 4.08 0 0 1 3.19 1.53l-1.17.94A2.58 2.58 0 0 0 8.4 2.5zm3.51 7.75h1.58A3.82 3.82 0 0 1 8.86 15h-.67a4.5 4.5 0 0 1-4.11-2.67l-.01-.02 1.37-.61.01.02a3 3 0 0 0 2.74 1.78h.67a2.32 2.32 0 0 0 2.12-3.25m4.02-3H1v1.5h14z"/>`
    }, props));
$e575e217847495ac$var$TextStrikethroughIcon.displayName = 'TextStrikethroughIcon';
var $e575e217847495ac$var$_default = module.exports.default = $e575e217847495ac$var$TextStrikethroughIcon;

});

parcelRegister("5gydP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f0917f4199f5ead8e2ff316703c32c4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d58fe253466b571$var$_react = $3d58fe253466b571$var$_interopRequireDefault((parcelRequire("42omo")));

var $3d58fe253466b571$var$_baseNew = $3d58fe253466b571$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3d58fe253466b571$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d58fe253466b571$var$TextStyleIcon = (props)=>/*#__PURE__*/ $3d58fe253466b571$var$_react.default.createElement($3d58fe253466b571$var$_baseNew.default, Object.assign({
        name: "TextStyleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$3d58fe253466b571$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $3d58fe253466b571$var$_default = module.exports.default = $3d58fe253466b571$var$TextStyleIcon;

});

parcelRegister("4E5My", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e6328b238b4e1d4c8883ade823798f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $361f62118221568e$var$_react = $361f62118221568e$var$_interopRequireDefault((parcelRequire("42omo")));

var $361f62118221568e$var$_baseNew = $361f62118221568e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $361f62118221568e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextUnderline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for underlined text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $361f62118221568e$var$TextUnderlineIcon = (props)=>/*#__PURE__*/ $361f62118221568e$var$_react.default.createElement($361f62118221568e$var$_baseNew.default, Object.assign({
        name: "TextUnderlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 8V1H5v7a3 3 0 0 0 6 0V1h1.5v7a4.5 4.5 0 1 1-9 0M0 16v-1.5h16V16z" clip-rule="evenodd"/>`
    }, props));
$361f62118221568e$var$TextUnderlineIcon.displayName = 'TextUnderlineIcon';
var $361f62118221568e$var$_default = module.exports.default = $361f62118221568e$var$TextUnderlineIcon;

});

parcelRegister("aK2ZC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2eb42ffff47552bf7695cd1247757bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d20859794a36c61$var$_react = $7d20859794a36c61$var$_interopRequireDefault((parcelRequire("42omo")));

var $7d20859794a36c61$var$_baseNew = $7d20859794a36c61$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7d20859794a36c61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextWrap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for wrapping text so it spans multiple lines.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d20859794a36c61$var$TextWrapIcon = (props)=>/*#__PURE__*/ $7d20859794a36c61$var$_react.default.createElement($7d20859794a36c61$var$_baseNew.default, Object.assign({
        name: "TextWrapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.375 5H0V3.5h13.375A2.625 2.625 0 0 1 16 6.125v2.75a2.625 2.625 0 0 1-2.625 2.625H9.561l1.72 1.72-1.061 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L9.56 10h3.815c.621 0 1.125-.504 1.125-1.125v-2.75C14.5 5.504 13.996 5 13.375 5M5 11.5H0V10h5z" clip-rule="evenodd"/>`
    }, props));
$7d20859794a36c61$var$TextWrapIcon.displayName = 'TextWrapIcon';
var $7d20859794a36c61$var$_default = module.exports.default = $7d20859794a36c61$var$TextWrapIcon;

});

parcelRegister("9zIwY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20d0f335103d15624fb4f6fc4abbdad2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f89ecda342ba131$var$_react = $6f89ecda342ba131$var$_interopRequireDefault((parcelRequire("42omo")));

var $6f89ecda342ba131$var$_baseNew = $6f89ecda342ba131$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6f89ecda342ba131$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f89ecda342ba131$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $6f89ecda342ba131$var$_react.default.createElement($6f89ecda342ba131$var$_baseNew.default, Object.assign({
        name: "ThumbsDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.292 13.406a.5.5 0 0 0 .77-.15l2.438-4.69V2.5H4.128c-.492 0-.927.32-1.073.79L1.726 7.54A1.125 1.125 0 0 0 2.8 9h3.45a.75.75 0 0 1 .75.75v3.175a.5.5 0 0 0 .174.38zM12 2.5V8h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm-.295 7-2.313 4.45a2 2 0 0 1-3.076.596l-.118-.101a2 2 0 0 1-.698-1.519V10.5H2.8A2.625 2.625 0 0 1 .295 7.092l1.328-4.25A2.625 2.625 0 0 1 4.128 1H14a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2z" clip-rule="evenodd"/>`
    }, props));
$6f89ecda342ba131$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $6f89ecda342ba131$var$_default = module.exports.default = $6f89ecda342ba131$var$ThumbsDownIcon;

});

parcelRegister("9FnLD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bf82c15bca1a56d27012abd5cecbc7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $709a61159e3249e0$var$_react = $709a61159e3249e0$var$_interopRequireDefault((parcelRequire("42omo")));

var $709a61159e3249e0$var$_baseNew = $709a61159e3249e0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $709a61159e3249e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $709a61159e3249e0$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $709a61159e3249e0$var$_react.default.createElement($709a61159e3249e0$var$_baseNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$709a61159e3249e0$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $709a61159e3249e0$var$_default = module.exports.default = $709a61159e3249e0$var$ThumbsUpIcon;

});

parcelRegister("5lVpa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d776e090c71d4272dea1a04d82939ee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e5b7151f1fdca09$var$_react = $3e5b7151f1fdca09$var$_interopRequireDefault((parcelRequire("42omo")));

var $3e5b7151f1fdca09$var$_baseNew = $3e5b7151f1fdca09$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3e5b7151f1fdca09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoStopOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for stopping video content. Use on dark or translucent backgrounds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e5b7151f1fdca09$var$VideoStopOverlayIcon = (props)=>/*#__PURE__*/ $3e5b7151f1fdca09$var$_react.default.createElement($3e5b7151f1fdca09$var$_baseNew.default, Object.assign({
        name: "VideoStopOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M2.5 3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z"/>`
    }, props));
$3e5b7151f1fdca09$var$VideoStopOverlayIcon.displayName = 'VideoStopOverlayIcon';
var $3e5b7151f1fdca09$var$_default = module.exports.default = $3e5b7151f1fdca09$var$VideoStopOverlayIcon;

});

parcelRegister("ZDq1z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63bc83d2df21e8aa09401170cfaa4b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b94465cb6c9f0e8$var$_react = $0b94465cb6c9f0e8$var$_interopRequireDefault((parcelRequire("42omo")));

var $0b94465cb6c9f0e8$var$_baseNew = $0b94465cb6c9f0e8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0b94465cb6c9f0e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b94465cb6c9f0e8$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $0b94465cb6c9f0e8$var$_react.default.createElement($0b94465cb6c9f0e8$var$_baseNew.default, Object.assign({
        name: "WhiteboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$0b94465cb6c9f0e8$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $0b94465cb6c9f0e8$var$_default = module.exports.default = $0b94465cb6c9f0e8$var$WhiteboardIcon;

});

parcelRegister("2qVkt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c5a7ad9346f91a5$var$_react = $1c5a7ad9346f91a5$var$_interopRequireDefault((parcelRequire("42omo")));

var $1c5a7ad9346f91a5$var$_baseNew = $1c5a7ad9346f91a5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1c5a7ad9346f91a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c5a7ad9346f91a5$var$WorkItemIcon = (props)=>/*#__PURE__*/ $1c5a7ad9346f91a5$var$_react.default.createElement($1c5a7ad9346f91a5$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$1c5a7ad9346f91a5$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $1c5a7ad9346f91a5$var$_default = module.exports.default = $1c5a7ad9346f91a5$var$WorkItemIcon;

});

parcelRegister("8jHAi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e1e803c59fc672$var$_react = $60e1e803c59fc672$var$_interopRequireDefault((parcelRequire("42omo")));

var $60e1e803c59fc672$var$_baseNew = $60e1e803c59fc672$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $60e1e803c59fc672$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e1e803c59fc672$var$PageIcon = (props)=>/*#__PURE__*/ $60e1e803c59fc672$var$_react.default.createElement($60e1e803c59fc672$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$60e1e803c59fc672$var$PageIcon.displayName = 'PageIcon';
var $60e1e803c59fc672$var$_default = module.exports.default = $60e1e803c59fc672$var$PageIcon;

});

parcelRegister("1dKyn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f93b4fc46a2af93e5da0e2c365640ac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e3b1de532be22c3$var$_react = $0e3b1de532be22c3$var$_interopRequireDefault((parcelRequire("42omo")));

var $0e3b1de532be22c3$var$_baseNew = $0e3b1de532be22c3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0e3b1de532be22c3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e3b1de532be22c3$var$TeamsIcon = (props)=>/*#__PURE__*/ $0e3b1de532be22c3$var$_react.default.createElement($0e3b1de532be22c3$var$_baseNew.default, Object.assign({
        name: "TeamsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$0e3b1de532be22c3$var$TeamsIcon.displayName = 'TeamsIcon';
var $0e3b1de532be22c3$var$_default = module.exports.default = $0e3b1de532be22c3$var$TeamsIcon;

});

parcelRegister("8DN9t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $019f9d4947dadb8d$var$_react = $019f9d4947dadb8d$var$_interopRequireDefault((parcelRequire("42omo")));

var $019f9d4947dadb8d$var$_baseNew = $019f9d4947dadb8d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $019f9d4947dadb8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $019f9d4947dadb8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $019f9d4947dadb8d$var$_react.default.createElement($019f9d4947dadb8d$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$019f9d4947dadb8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $019f9d4947dadb8d$var$_default = module.exports.default = $019f9d4947dadb8d$var$CalendarIcon;

});

parcelRegister("9eEg2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1c30d577c7234bb5109e7b6cea91ee6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b94a631f0b72fed$var$_react = $6b94a631f0b72fed$var$_interopRequireDefault((parcelRequire("42omo")));

var $6b94a631f0b72fed$var$_baseNew = $6b94a631f0b72fed$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6b94a631f0b72fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b94a631f0b72fed$var$EmojiIcon = (props)=>/*#__PURE__*/ $6b94a631f0b72fed$var$_react.default.createElement($6b94a631f0b72fed$var$_baseNew.default, Object.assign({
        name: "EmojiIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$6b94a631f0b72fed$var$EmojiIcon.displayName = 'EmojiIcon';
var $6b94a631f0b72fed$var$_default = module.exports.default = $6b94a631f0b72fed$var$EmojiIcon;

});

parcelRegister("6767u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0126111c05935b08$var$_react = $0126111c05935b08$var$_interopRequireDefault((parcelRequire("42omo")));

var $0126111c05935b08$var$_baseNew = $0126111c05935b08$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0126111c05935b08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0126111c05935b08$var$PersonIcon = (props)=>/*#__PURE__*/ $0126111c05935b08$var$_react.default.createElement($0126111c05935b08$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$0126111c05935b08$var$PersonIcon.displayName = 'PersonIcon';
var $0126111c05935b08$var$_default = module.exports.default = $0126111c05935b08$var$PersonIcon;

});

parcelRegister("4FHTF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf6065af0d56e84610020204bbc954cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $366d0ac32486011a$var$_react = $366d0ac32486011a$var$_interopRequireDefault((parcelRequire("42omo")));

var $366d0ac32486011a$var$_baseNew = $366d0ac32486011a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $366d0ac32486011a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $366d0ac32486011a$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $366d0ac32486011a$var$_react.default.createElement($366d0ac32486011a$var$_baseNew.default, Object.assign({
        name: "EmojiAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$366d0ac32486011a$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $366d0ac32486011a$var$_default = module.exports.default = $366d0ac32486011a$var$EmojiAddIcon;

});

parcelRegister("ci7Ox", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f2d3a379cb5e0d2$var$_react = $8f2d3a379cb5e0d2$var$_interopRequireDefault((parcelRequire("42omo")));

var $8f2d3a379cb5e0d2$var$_baseNew = $8f2d3a379cb5e0d2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8f2d3a379cb5e0d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f2d3a379cb5e0d2$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $8f2d3a379cb5e0d2$var$_react.default.createElement($8f2d3a379cb5e0d2$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$8f2d3a379cb5e0d2$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $8f2d3a379cb5e0d2$var$_default = module.exports.default = $8f2d3a379cb5e0d2$var$QuestionCircleIcon;

});

parcelRegister("1bY7o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0de573c382459987$var$_react = $0de573c382459987$var$_interopRequireDefault((parcelRequire("42omo")));

var $0de573c382459987$var$_baseNew = $0de573c382459987$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0de573c382459987$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0de573c382459987$var$LinkIcon = (props)=>/*#__PURE__*/ $0de573c382459987$var$_react.default.createElement($0de573c382459987$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0de573c382459987$var$LinkIcon.displayName = 'LinkIcon';
var $0de573c382459987$var$_default = module.exports.default = $0de573c382459987$var$LinkIcon;

});

parcelRegister("lE8sM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4115a2d35a14dc8$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $eCcCl = parcelRequire("eCcCl");


var $1boGo = parcelRequire("1boGo");

// Color mapping for size 16 standalone icons that will no longer be tiles
const $c4115a2d35a14dc8$var$appearanceToIconColorMap = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
function $c4115a2d35a14dc8$export$2e2bcd8739ae039({ appearance: appearance, icon: Icon, label: label, size: size, testId: testId, shape: shape, LEGACY_fallbackComponent: LEGACY_fallbackComponent, UNSAFE_circleReplacementComponent: UNSAFE_circleReplacementComponent }) {
    if (LEGACY_fallbackComponent && !(0, $dh538.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    if (UNSAFE_circleReplacementComponent && shape === 'circle' && ((0, $dh538.fg)('platform_dst_icon_tile_circle_replacement') || (0, $dh538.fg)('platform_dst_icon_tile_circle_replacement_stage2'))) return UNSAFE_circleReplacementComponent;
    if (shape !== 'circle' && ((0, $dh538.fg)('platform_dst_new_icon_tile') || (0, $dh538.fg)('platform_dst_new_icon_tile_stage2'))) {
        // Handle size 16 - render icon directly without Tile
        if (size === '16') return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            color: $c4115a2d35a14dc8$var$appearanceToIconColorMap[appearance],
            label: label,
            testId: testId
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eCcCl.default), {
            appearance: appearance,
            icon: Icon,
            label: label,
            shape: shape,
            size: size,
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1boGo.default), {
        appearance: appearance,
        icon: Icon,
        label: label,
        shape: shape,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9aGns", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ad5eb77a9d7cb1f$var$_react = $6ad5eb77a9d7cb1f$var$_interopRequireDefault((parcelRequire("42omo")));

var $6ad5eb77a9d7cb1f$var$_baseNew = $6ad5eb77a9d7cb1f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6ad5eb77a9d7cb1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ad5eb77a9d7cb1f$var$DownloadIcon = (props)=>/*#__PURE__*/ $6ad5eb77a9d7cb1f$var$_react.default.createElement($6ad5eb77a9d7cb1f$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$6ad5eb77a9d7cb1f$var$DownloadIcon.displayName = 'DownloadIcon';
var $6ad5eb77a9d7cb1f$var$_default = module.exports.default = $6ad5eb77a9d7cb1f$var$DownloadIcon;

});

parcelRegister("SZOxu", function(module, exports) {
const $0cf93e9d3df78fcc$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $0cf93e9d3df78fcc$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $0cf93e9d3df78fcc$export$62ad7b0c781000e9 = {
    small: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.small,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.medium,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.large,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.xlarge,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.xlarge
    }
};
module.exports["sizes"] = $0cf93e9d3df78fcc$export$c647cb0ee6e282fe;
module.exports["sizeMap"] = $0cf93e9d3df78fcc$export$7bd66fc94c81bf84;

});

parcelRegister("hw7wB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc4f0315b11d9afea68ddf0758e998e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc0b431723a27b6e$var$_react = $cc0b431723a27b6e$var$_interopRequireDefault((parcelRequire("42omo")));

var $cc0b431723a27b6e$var$_baseNew = $cc0b431723a27b6e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cc0b431723a27b6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc0b431723a27b6e$var$UploadIcon = (props)=>/*#__PURE__*/ $cc0b431723a27b6e$var$_react.default.createElement($cc0b431723a27b6e$var$_baseNew.default, Object.assign({
        name: "UploadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$cc0b431723a27b6e$var$UploadIcon.displayName = 'UploadIcon';
var $cc0b431723a27b6e$var$_default = module.exports.default = $cc0b431723a27b6e$var$UploadIcon;

});

parcelRegister("kFjZK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::212245c1584bec684ced80344b70bcc4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0b7258cd45dc8d2$var$_react = $f0b7258cd45dc8d2$var$_interopRequireDefault((parcelRequire("42omo")));

var $f0b7258cd45dc8d2$var$_baseNew = $f0b7258cd45dc8d2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f0b7258cd45dc8d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0b7258cd45dc8d2$var$RedoIcon = (props)=>/*#__PURE__*/ $f0b7258cd45dc8d2$var$_react.default.createElement($f0b7258cd45dc8d2$var$_baseNew.default, Object.assign({
        name: "RedoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 0 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$f0b7258cd45dc8d2$var$RedoIcon.displayName = 'RedoIcon';
var $f0b7258cd45dc8d2$var$_default = module.exports.default = $f0b7258cd45dc8d2$var$RedoIcon;

});

parcelRegister("22Iw9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17ce4cee627292b0$var$_react = $17ce4cee627292b0$var$_interopRequireDefault((parcelRequire("42omo")));

var $17ce4cee627292b0$var$_baseNew = $17ce4cee627292b0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17ce4cee627292b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17ce4cee627292b0$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $17ce4cee627292b0$var$_react.default.createElement($17ce4cee627292b0$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$17ce4cee627292b0$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $17ce4cee627292b0$var$_default = module.exports.default = $17ce4cee627292b0$var$ArrowDownIcon;

});

parcelRegister("5aaqS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::411fb0e87ff78661e4fe4f98c48af3ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c25fa9ac9257d0d$var$_react = $3c25fa9ac9257d0d$var$_interopRequireDefault((parcelRequire("42omo")));

var $3c25fa9ac9257d0d$var$_baseNew = $3c25fa9ac9257d0d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3c25fa9ac9257d0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c25fa9ac9257d0d$var$BoardIcon = (props)=>/*#__PURE__*/ $3c25fa9ac9257d0d$var$_react.default.createElement($3c25fa9ac9257d0d$var$_baseNew.default, Object.assign({
        name: "BoardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3c25fa9ac9257d0d$var$BoardIcon.displayName = 'BoardIcon';
var $3c25fa9ac9257d0d$var$_default = module.exports.default = $3c25fa9ac9257d0d$var$BoardIcon;

});


$parcel$global.rlb("6wr18")
//# sourceMappingURL=vendors~editor_icon.ae2cf182.js.map
